
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire2f9e"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire2f9e"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("800sp", function(module, exports) {
$parcel$export(module.exports, "css", () => (parcelRequire("4jdI8")).css);
$parcel$export(module.exports, "html", () => (parcelRequire("jJTNo")).html);
$parcel$export(module.exports, "LitElement", () => (parcelRequire("lPSdM")).LitElement);
$parcel$export(module.exports, "nothing", () => (parcelRequire("jJTNo")).nothing);
$parcel$export(module.exports, "supportsAdoptingStyleSheets", () => (parcelRequire("4jdI8")).supportsAdoptingStyleSheets);
parcelRequire("3qR54");
parcelRequire("jJTNo");
parcelRequire("lPSdM");
parcelRequire("8FVzH");

});
parcelRegister("3qR54", function(module, exports) {

$parcel$export(module.exports, "ReactiveElement", () => $27fcf98b67c2a783$export$c7c07a37856565d);
$parcel$export(module.exports, "css", () => (parcelRequire("4jdI8")).css);
$parcel$export(module.exports, "supportsAdoptingStyleSheets", () => (parcelRequire("4jdI8")).supportsAdoptingStyleSheets);

var $4jdI8 = parcelRequire("4jdI8");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ var $27fcf98b67c2a783$var$s;
const $27fcf98b67c2a783$var$e = window, $27fcf98b67c2a783$var$r = $27fcf98b67c2a783$var$e.trustedTypes, $27fcf98b67c2a783$var$h = $27fcf98b67c2a783$var$r ? $27fcf98b67c2a783$var$r.emptyScript : "", $27fcf98b67c2a783$var$o = $27fcf98b67c2a783$var$e.reactiveElementPolyfillSupport, $27fcf98b67c2a783$export$7312b35fbf521afb = {
    toAttribute (t, i) {
        switch(i){
            case Boolean:
                t = t ? $27fcf98b67c2a783$var$h : null;
                break;
            case Object:
            case Array:
                t = null == t ? t : JSON.stringify(t);
        }
        return t;
    },
    fromAttribute (t, i) {
        let s = t;
        switch(i){
            case Boolean:
                s = null !== t;
                break;
            case Number:
                s = null === t ? null : Number(t);
                break;
            case Object:
            case Array:
                try {
                    s = JSON.parse(t);
                } catch (t) {
                    s = null;
                }
        }
        return s;
    }
}, $27fcf98b67c2a783$export$53a6892c50694894 = (t, i)=>i !== t && (i == i || t == t), $27fcf98b67c2a783$var$l = {
    attribute: !0,
    type: String,
    converter: $27fcf98b67c2a783$export$7312b35fbf521afb,
    reflect: !1,
    hasChanged: $27fcf98b67c2a783$export$53a6892c50694894
};
class $27fcf98b67c2a783$export$c7c07a37856565d extends HTMLElement {
    constructor(){
        super(), this._$Ei = new Map, this.isUpdatePending = !1, this.hasUpdated = !1, this._$El = null, this.u();
    }
    static addInitializer(t) {
        var i;
        this.finalize(), (null !== (i = this.h) && void 0 !== i ? i : this.h = []).push(t);
    }
    static get observedAttributes() {
        this.finalize();
        const t = [];
        return this.elementProperties.forEach((i, s)=>{
            const e = this._$Ep(s, i);
            void 0 !== e && (this._$Ev.set(e, s), t.push(e));
        }), t;
    }
    static createProperty(t, i = $27fcf98b67c2a783$var$l) {
        if (i.state && (i.attribute = !1), this.finalize(), this.elementProperties.set(t, i), !i.noAccessor && !this.prototype.hasOwnProperty(t)) {
            const s = "symbol" == typeof t ? Symbol() : "__" + t, e = this.getPropertyDescriptor(t, s, i);
            void 0 !== e && Object.defineProperty(this.prototype, t, e);
        }
    }
    static getPropertyDescriptor(t, i, s) {
        return {
            get () {
                return this[i];
            },
            set (e) {
                const r = this[t];
                this[i] = e, this.requestUpdate(t, r, s);
            },
            configurable: !0,
            enumerable: !0
        };
    }
    static getPropertyOptions(t) {
        return this.elementProperties.get(t) || $27fcf98b67c2a783$var$l;
    }
    static finalize() {
        if (this.hasOwnProperty("finalized")) return !1;
        this.finalized = !0;
        const t = Object.getPrototypeOf(this);
        if (t.finalize(), void 0 !== t.h && (this.h = [
            ...t.h
        ]), this.elementProperties = new Map(t.elementProperties), this._$Ev = new Map, this.hasOwnProperty("properties")) {
            const t = this.properties, i = [
                ...Object.getOwnPropertyNames(t),
                ...Object.getOwnPropertySymbols(t)
            ];
            for (const s of i)this.createProperty(s, t[s]);
        }
        return this.elementStyles = this.finalizeStyles(this.styles), !0;
    }
    static finalizeStyles(i) {
        const s = [];
        if (Array.isArray(i)) {
            const e = new Set(i.flat(1 / 0).reverse());
            for (const i of e)s.unshift((0, $4jdI8.getCompatibleStyle)(i));
        } else void 0 !== i && s.push((0, $4jdI8.getCompatibleStyle)(i));
        return s;
    }
    static _$Ep(t, i) {
        const s = i.attribute;
        return !1 === s ? void 0 : "string" == typeof s ? s : "string" == typeof t ? t.toLowerCase() : void 0;
    }
    u() {
        var t;
        this._$E_ = new Promise((t)=>this.enableUpdating = t), this._$AL = new Map, this._$Eg(), this.requestUpdate(), null === (t = this.constructor.h) || void 0 === t || t.forEach((t)=>t(this));
    }
    addController(t) {
        var i, s;
        (null !== (i = this._$ES) && void 0 !== i ? i : this._$ES = []).push(t), void 0 !== this.renderRoot && this.isConnected && (null === (s = t.hostConnected) || void 0 === s || s.call(t));
    }
    removeController(t) {
        var i;
        null === (i = this._$ES) || void 0 === i || i.splice(this._$ES.indexOf(t) >>> 0, 1);
    }
    _$Eg() {
        this.constructor.elementProperties.forEach((t, i)=>{
            this.hasOwnProperty(i) && (this._$Ei.set(i, this[i]), delete this[i]);
        });
    }
    createRenderRoot() {
        var t;
        const s = null !== (t = this.shadowRoot) && void 0 !== t ? t : this.attachShadow(this.constructor.shadowRootOptions);
        return (0, $4jdI8.adoptStyles)(s, this.constructor.elementStyles), s;
    }
    connectedCallback() {
        var t;
        void 0 === this.renderRoot && (this.renderRoot = this.createRenderRoot()), this.enableUpdating(!0), null === (t = this._$ES) || void 0 === t || t.forEach((t)=>{
            var i;
            return null === (i = t.hostConnected) || void 0 === i ? void 0 : i.call(t);
        });
    }
    enableUpdating(t) {}
    disconnectedCallback() {
        var t;
        null === (t = this._$ES) || void 0 === t || t.forEach((t)=>{
            var i;
            return null === (i = t.hostDisconnected) || void 0 === i ? void 0 : i.call(t);
        });
    }
    attributeChangedCallback(t, i, s) {
        this._$AK(t, s);
    }
    _$EO(t, i, s = $27fcf98b67c2a783$var$l) {
        var e;
        const r = this.constructor._$Ep(t, s);
        if (void 0 !== r && !0 === s.reflect) {
            const h = (void 0 !== (null === (e = s.converter) || void 0 === e ? void 0 : e.toAttribute) ? s.converter : $27fcf98b67c2a783$export$7312b35fbf521afb).toAttribute(i, s.type);
            this._$El = t, null == h ? this.removeAttribute(r) : this.setAttribute(r, h), this._$El = null;
        }
    }
    _$AK(t, i) {
        var s;
        const e = this.constructor, r = e._$Ev.get(t);
        if (void 0 !== r && this._$El !== r) {
            const t = e.getPropertyOptions(r), h = "function" == typeof t.converter ? {
                fromAttribute: t.converter
            } : void 0 !== (null === (s = t.converter) || void 0 === s ? void 0 : s.fromAttribute) ? t.converter : $27fcf98b67c2a783$export$7312b35fbf521afb;
            this._$El = r, this[r] = h.fromAttribute(i, t.type), this._$El = null;
        }
    }
    requestUpdate(t, i, s) {
        let e = !0;
        void 0 !== t && (((s = s || this.constructor.getPropertyOptions(t)).hasChanged || $27fcf98b67c2a783$export$53a6892c50694894)(this[t], i) ? (this._$AL.has(t) || this._$AL.set(t, i), !0 === s.reflect && this._$El !== t && (void 0 === this._$EC && (this._$EC = new Map), this._$EC.set(t, s))) : e = !1), !this.isUpdatePending && e && (this._$E_ = this._$Ej());
    }
    async _$Ej() {
        this.isUpdatePending = !0;
        try {
            await this._$E_;
        } catch (t) {
            Promise.reject(t);
        }
        const t = this.scheduleUpdate();
        return null != t && await t, !this.isUpdatePending;
    }
    scheduleUpdate() {
        return this.performUpdate();
    }
    performUpdate() {
        var t;
        if (!this.isUpdatePending) return;
        this.hasUpdated, this._$Ei && (this._$Ei.forEach((t, i)=>this[i] = t), this._$Ei = void 0);
        let i = !1;
        const s = this._$AL;
        try {
            i = this.shouldUpdate(s), i ? (this.willUpdate(s), null === (t = this._$ES) || void 0 === t || t.forEach((t)=>{
                var i;
                return null === (i = t.hostUpdate) || void 0 === i ? void 0 : i.call(t);
            }), this.update(s)) : this._$Ek();
        } catch (t) {
            throw i = !1, this._$Ek(), t;
        }
        i && this._$AE(s);
    }
    willUpdate(t) {}
    _$AE(t) {
        var i;
        null === (i = this._$ES) || void 0 === i || i.forEach((t)=>{
            var i;
            return null === (i = t.hostUpdated) || void 0 === i ? void 0 : i.call(t);
        }), this.hasUpdated || (this.hasUpdated = !0, this.firstUpdated(t)), this.updated(t);
    }
    _$Ek() {
        this._$AL = new Map, this.isUpdatePending = !1;
    }
    get updateComplete() {
        return this.getUpdateComplete();
    }
    getUpdateComplete() {
        return this._$E_;
    }
    shouldUpdate(t) {
        return !0;
    }
    update(t) {
        void 0 !== this._$EC && (this._$EC.forEach((t, i)=>this._$EO(i, this[i], t)), this._$EC = void 0), this._$Ek();
    }
    updated(t) {}
    firstUpdated(t) {}
}
$27fcf98b67c2a783$export$c7c07a37856565d.finalized = !0, $27fcf98b67c2a783$export$c7c07a37856565d.elementProperties = new Map, $27fcf98b67c2a783$export$c7c07a37856565d.elementStyles = [], $27fcf98b67c2a783$export$c7c07a37856565d.shadowRootOptions = {
    mode: "open"
}, null == $27fcf98b67c2a783$var$o || $27fcf98b67c2a783$var$o({
    ReactiveElement: $27fcf98b67c2a783$export$c7c07a37856565d
}), (null !== ($27fcf98b67c2a783$var$s = $27fcf98b67c2a783$var$e.reactiveElementVersions) && void 0 !== $27fcf98b67c2a783$var$s ? $27fcf98b67c2a783$var$s : $27fcf98b67c2a783$var$e.reactiveElementVersions = []).push("1.6.1");

});
parcelRegister("4jdI8", function(module, exports) {

$parcel$export(module.exports, "supportsAdoptingStyleSheets", () => $3233927aa82734f9$export$b4d10f6001c083c2);
$parcel$export(module.exports, "css", () => $3233927aa82734f9$export$dbf350e5966cf602);
$parcel$export(module.exports, "adoptStyles", () => $3233927aa82734f9$export$2ca4a66ec4cecb90);
$parcel$export(module.exports, "getCompatibleStyle", () => $3233927aa82734f9$export$ee69dfd951e24778);
/**
 * @license
 * Copyright 2019 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $3233927aa82734f9$var$t = window, $3233927aa82734f9$export$b4d10f6001c083c2 = $3233927aa82734f9$var$t.ShadowRoot && (void 0 === $3233927aa82734f9$var$t.ShadyCSS || $3233927aa82734f9$var$t.ShadyCSS.nativeShadow) && "adoptedStyleSheets" in Document.prototype && "replace" in CSSStyleSheet.prototype, $3233927aa82734f9$var$s = Symbol(), $3233927aa82734f9$var$n = new WeakMap;
class $3233927aa82734f9$export$505d1e8739bad805 {
    constructor(t, e, n){
        if (this._$cssResult$ = !0, n !== $3233927aa82734f9$var$s) throw Error("CSSResult is not constructable. Use `unsafeCSS` or `css` instead.");
        this.cssText = t, this.t = e;
    }
    get styleSheet() {
        let t = this.o;
        const s = this.t;
        if ($3233927aa82734f9$export$b4d10f6001c083c2 && void 0 === t) {
            const e = void 0 !== s && 1 === s.length;
            e && (t = $3233927aa82734f9$var$n.get(s)), void 0 === t && ((this.o = t = new CSSStyleSheet).replaceSync(this.cssText), e && $3233927aa82734f9$var$n.set(s, t));
        }
        return t;
    }
    toString() {
        return this.cssText;
    }
}
const $3233927aa82734f9$export$8d80f9cac07cdb3 = (t)=>new $3233927aa82734f9$export$505d1e8739bad805("string" == typeof t ? t : t + "", void 0, $3233927aa82734f9$var$s), $3233927aa82734f9$export$dbf350e5966cf602 = (t, ...e)=>{
    const n = 1 === t.length ? t[0] : e.reduce((e, s, n)=>e + ((t)=>{
            if (!0 === t._$cssResult$) return t.cssText;
            if ("number" == typeof t) return t;
            throw Error("Value passed to 'css' function must be a 'css' function result: " + t + ". Use 'unsafeCSS' to pass non-literal values, but take care to ensure page security.");
        })(s) + t[n + 1], t[0]);
    return new $3233927aa82734f9$export$505d1e8739bad805(n, t, $3233927aa82734f9$var$s);
}, $3233927aa82734f9$export$2ca4a66ec4cecb90 = (s, n)=>{
    $3233927aa82734f9$export$b4d10f6001c083c2 ? s.adoptedStyleSheets = n.map((t)=>t instanceof CSSStyleSheet ? t : t.styleSheet) : n.forEach((e)=>{
        const n = document.createElement("style"), o = $3233927aa82734f9$var$t.litNonce;
        void 0 !== o && n.setAttribute("nonce", o), n.textContent = e.cssText, s.appendChild(n);
    });
}, $3233927aa82734f9$export$ee69dfd951e24778 = $3233927aa82734f9$export$b4d10f6001c083c2 ? (t)=>t : (t)=>t instanceof CSSStyleSheet ? ((t)=>{
        let e = "";
        for (const s of t.cssRules)e += s.cssText;
        return $3233927aa82734f9$export$8d80f9cac07cdb3(e);
    })(t) : t;

});


parcelRegister("jJTNo", function(module, exports) {

$parcel$export(module.exports, "html", () => $e5ed8027d647799b$export$c0bb0b647f701bb5);
$parcel$export(module.exports, "noChange", () => $e5ed8027d647799b$export$9c068ae9cc5db4e8);
$parcel$export(module.exports, "nothing", () => $e5ed8027d647799b$export$45b790e32b2810ee);
$parcel$export(module.exports, "render", () => $e5ed8027d647799b$export$b3890eb0ae9dca99);
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ var $e5ed8027d647799b$var$t;
const $e5ed8027d647799b$var$i = window, $e5ed8027d647799b$var$s = $e5ed8027d647799b$var$i.trustedTypes, $e5ed8027d647799b$var$e = $e5ed8027d647799b$var$s ? $e5ed8027d647799b$var$s.createPolicy("lit-html", {
    createHTML: (t)=>t
}) : void 0, $e5ed8027d647799b$var$o = "$lit$", $e5ed8027d647799b$var$n = `lit$${(Math.random() + "").slice(9)}$`, $e5ed8027d647799b$var$l = "?" + $e5ed8027d647799b$var$n, $e5ed8027d647799b$var$h = `<${$e5ed8027d647799b$var$l}>`, $e5ed8027d647799b$var$r = document, $e5ed8027d647799b$var$d = ()=>$e5ed8027d647799b$var$r.createComment(""), $e5ed8027d647799b$var$u = (t)=>null === t || "object" != typeof t && "function" != typeof t, $e5ed8027d647799b$var$c = Array.isArray, $e5ed8027d647799b$var$v = (t)=>$e5ed8027d647799b$var$c(t) || "function" == typeof (null == t ? void 0 : t[Symbol.iterator]), $e5ed8027d647799b$var$a = "[ 	\n\f\r]", $e5ed8027d647799b$var$f = /<(?:(!--|\/[^a-zA-Z])|(\/?[a-zA-Z][^>\s]*)|(\/?$))/g, $e5ed8027d647799b$var$_ = /-->/g, $e5ed8027d647799b$var$m = />/g, $e5ed8027d647799b$var$p = RegExp(`>|${$e5ed8027d647799b$var$a}(?:([^\\s"'>=/]+)(${$e5ed8027d647799b$var$a}*=${$e5ed8027d647799b$var$a}*(?:[^ \t\n\f\r"'\`<>=]|("|')|))|$)`, "g"), $e5ed8027d647799b$var$g = /'/g, $e5ed8027d647799b$var$$ = /"/g, $e5ed8027d647799b$var$y = /^(?:script|style|textarea|title)$/i, $e5ed8027d647799b$var$w = (t)=>(i, ...s)=>({
            _$litType$: t,
            strings: i,
            values: s
        }), $e5ed8027d647799b$export$c0bb0b647f701bb5 = $e5ed8027d647799b$var$w(1), $e5ed8027d647799b$export$7ed1367e7fa1ad68 = $e5ed8027d647799b$var$w(2), $e5ed8027d647799b$export$9c068ae9cc5db4e8 = Symbol.for("lit-noChange"), $e5ed8027d647799b$export$45b790e32b2810ee = Symbol.for("lit-nothing"), $e5ed8027d647799b$var$E = new WeakMap, $e5ed8027d647799b$var$C = $e5ed8027d647799b$var$r.createTreeWalker($e5ed8027d647799b$var$r, 129, null, !1), $e5ed8027d647799b$var$P = (t, i)=>{
    const s = t.length - 1, l = [];
    let r, d = 2 === i ? "<svg>" : "", u = $e5ed8027d647799b$var$f;
    for(let i = 0; i < s; i++){
        const s = t[i];
        let e, c, v = -1, a = 0;
        for(; a < s.length && (u.lastIndex = a, c = u.exec(s), null !== c);)a = u.lastIndex, u === $e5ed8027d647799b$var$f ? "!--" === c[1] ? u = $e5ed8027d647799b$var$_ : void 0 !== c[1] ? u = $e5ed8027d647799b$var$m : void 0 !== c[2] ? ($e5ed8027d647799b$var$y.test(c[2]) && (r = RegExp("</" + c[2], "g")), u = $e5ed8027d647799b$var$p) : void 0 !== c[3] && (u = $e5ed8027d647799b$var$p) : u === $e5ed8027d647799b$var$p ? ">" === c[0] ? (u = null != r ? r : $e5ed8027d647799b$var$f, v = -1) : void 0 === c[1] ? v = -2 : (v = u.lastIndex - c[2].length, e = c[1], u = void 0 === c[3] ? $e5ed8027d647799b$var$p : '"' === c[3] ? $e5ed8027d647799b$var$$ : $e5ed8027d647799b$var$g) : u === $e5ed8027d647799b$var$$ || u === $e5ed8027d647799b$var$g ? u = $e5ed8027d647799b$var$p : u === $e5ed8027d647799b$var$_ || u === $e5ed8027d647799b$var$m ? u = $e5ed8027d647799b$var$f : (u = $e5ed8027d647799b$var$p, r = void 0);
        const w = u === $e5ed8027d647799b$var$p && t[i + 1].startsWith("/>") ? " " : "";
        d += u === $e5ed8027d647799b$var$f ? s + $e5ed8027d647799b$var$h : v >= 0 ? (l.push(e), s.slice(0, v) + $e5ed8027d647799b$var$o + s.slice(v) + $e5ed8027d647799b$var$n + w) : s + $e5ed8027d647799b$var$n + (-2 === v ? (l.push(void 0), i) : w);
    }
    const c = d + (t[s] || "<?>") + (2 === i ? "</svg>" : "");
    if (!Array.isArray(t) || !t.hasOwnProperty("raw")) throw Error("invalid template strings array");
    return [
        void 0 !== $e5ed8027d647799b$var$e ? $e5ed8027d647799b$var$e.createHTML(c) : c,
        l
    ];
};
class $e5ed8027d647799b$var$V {
    constructor({ strings: t, _$litType$: i }, e){
        let h;
        this.parts = [];
        let r = 0, u = 0;
        const c = t.length - 1, v = this.parts, [a, f] = $e5ed8027d647799b$var$P(t, i);
        if (this.el = $e5ed8027d647799b$var$V.createElement(a, e), $e5ed8027d647799b$var$C.currentNode = this.el.content, 2 === i) {
            const t = this.el.content, i = t.firstChild;
            i.remove(), t.append(...i.childNodes);
        }
        for(; null !== (h = $e5ed8027d647799b$var$C.nextNode()) && v.length < c;){
            if (1 === h.nodeType) {
                if (h.hasAttributes()) {
                    const t = [];
                    for (const i of h.getAttributeNames())if (i.endsWith($e5ed8027d647799b$var$o) || i.startsWith($e5ed8027d647799b$var$n)) {
                        const s = f[u++];
                        if (t.push(i), void 0 !== s) {
                            const t = h.getAttribute(s.toLowerCase() + $e5ed8027d647799b$var$o).split($e5ed8027d647799b$var$n), i = /([.?@])?(.*)/.exec(s);
                            v.push({
                                type: 1,
                                index: r,
                                name: i[2],
                                strings: t,
                                ctor: "." === i[1] ? $e5ed8027d647799b$var$k : "?" === i[1] ? $e5ed8027d647799b$var$I : "@" === i[1] ? $e5ed8027d647799b$var$L : $e5ed8027d647799b$var$R
                            });
                        } else v.push({
                            type: 6,
                            index: r
                        });
                    }
                    for (const i of t)h.removeAttribute(i);
                }
                if ($e5ed8027d647799b$var$y.test(h.tagName)) {
                    const t = h.textContent.split($e5ed8027d647799b$var$n), i = t.length - 1;
                    if (i > 0) {
                        h.textContent = $e5ed8027d647799b$var$s ? $e5ed8027d647799b$var$s.emptyScript : "";
                        for(let s = 0; s < i; s++)h.append(t[s], $e5ed8027d647799b$var$d()), $e5ed8027d647799b$var$C.nextNode(), v.push({
                            type: 2,
                            index: ++r
                        });
                        h.append(t[i], $e5ed8027d647799b$var$d());
                    }
                }
            } else if (8 === h.nodeType) {
                if (h.data === $e5ed8027d647799b$var$l) v.push({
                    type: 2,
                    index: r
                });
                else {
                    let t = -1;
                    for(; -1 !== (t = h.data.indexOf($e5ed8027d647799b$var$n, t + 1));)v.push({
                        type: 7,
                        index: r
                    }), t += $e5ed8027d647799b$var$n.length - 1;
                }
            }
            r++;
        }
    }
    static createElement(t, i) {
        const s = $e5ed8027d647799b$var$r.createElement("template");
        return s.innerHTML = t, s;
    }
}
function $e5ed8027d647799b$var$N(t, i, s = t, e) {
    var o, n, l, h;
    if (i === $e5ed8027d647799b$export$9c068ae9cc5db4e8) return i;
    let r = void 0 !== e ? null === (o = s._$Co) || void 0 === o ? void 0 : o[e] : s._$Cl;
    const d = $e5ed8027d647799b$var$u(i) ? void 0 : i._$litDirective$;
    return (null == r ? void 0 : r.constructor) !== d && (null === (n = null == r ? void 0 : r._$AO) || void 0 === n || n.call(r, !1), void 0 === d ? r = void 0 : (r = new d(t), r._$AT(t, s, e)), void 0 !== e ? (null !== (l = (h = s)._$Co) && void 0 !== l ? l : h._$Co = [])[e] = r : s._$Cl = r), void 0 !== r && (i = $e5ed8027d647799b$var$N(t, r._$AS(t, i.values), r, e)), i;
}
class $e5ed8027d647799b$var$S {
    constructor(t, i){
        this._$AV = [], this._$AN = void 0, this._$AD = t, this._$AM = i;
    }
    get parentNode() {
        return this._$AM.parentNode;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    u(t) {
        var i;
        const { el: { content: s }, parts: e } = this._$AD, o = (null !== (i = null == t ? void 0 : t.creationScope) && void 0 !== i ? i : $e5ed8027d647799b$var$r).importNode(s, !0);
        $e5ed8027d647799b$var$C.currentNode = o;
        let n = $e5ed8027d647799b$var$C.nextNode(), l = 0, h = 0, d = e[0];
        for(; void 0 !== d;){
            if (l === d.index) {
                let i;
                2 === d.type ? i = new $e5ed8027d647799b$var$M(n, n.nextSibling, this, t) : 1 === d.type ? i = new d.ctor(n, d.name, d.strings, this, t) : 6 === d.type && (i = new $e5ed8027d647799b$var$z(n, this, t)), this._$AV.push(i), d = e[++h];
            }
            l !== (null == d ? void 0 : d.index) && (n = $e5ed8027d647799b$var$C.nextNode(), l++);
        }
        return o;
    }
    v(t) {
        let i = 0;
        for (const s of this._$AV)void 0 !== s && (void 0 !== s.strings ? (s._$AI(t, s, i), i += s.strings.length - 2) : s._$AI(t[i])), i++;
    }
}
class $e5ed8027d647799b$var$M {
    constructor(t, i, s, e){
        var o;
        this.type = 2, this._$AH = $e5ed8027d647799b$export$45b790e32b2810ee, this._$AN = void 0, this._$AA = t, this._$AB = i, this._$AM = s, this.options = e, this._$Cp = null === (o = null == e ? void 0 : e.isConnected) || void 0 === o || o;
    }
    get _$AU() {
        var t, i;
        return null !== (i = null === (t = this._$AM) || void 0 === t ? void 0 : t._$AU) && void 0 !== i ? i : this._$Cp;
    }
    get parentNode() {
        let t = this._$AA.parentNode;
        const i = this._$AM;
        return void 0 !== i && 11 === (null == t ? void 0 : t.nodeType) && (t = i.parentNode), t;
    }
    get startNode() {
        return this._$AA;
    }
    get endNode() {
        return this._$AB;
    }
    _$AI(t, i = this) {
        t = $e5ed8027d647799b$var$N(this, t, i), $e5ed8027d647799b$var$u(t) ? t === $e5ed8027d647799b$export$45b790e32b2810ee || null == t || "" === t ? (this._$AH !== $e5ed8027d647799b$export$45b790e32b2810ee && this._$AR(), this._$AH = $e5ed8027d647799b$export$45b790e32b2810ee) : t !== this._$AH && t !== $e5ed8027d647799b$export$9c068ae9cc5db4e8 && this._(t) : void 0 !== t._$litType$ ? this.g(t) : void 0 !== t.nodeType ? this.$(t) : $e5ed8027d647799b$var$v(t) ? this.T(t) : this._(t);
    }
    k(t) {
        return this._$AA.parentNode.insertBefore(t, this._$AB);
    }
    $(t) {
        this._$AH !== t && (this._$AR(), this._$AH = this.k(t));
    }
    _(t) {
        this._$AH !== $e5ed8027d647799b$export$45b790e32b2810ee && $e5ed8027d647799b$var$u(this._$AH) ? this._$AA.nextSibling.data = t : this.$($e5ed8027d647799b$var$r.createTextNode(t)), this._$AH = t;
    }
    g(t) {
        var i;
        const { values: s, _$litType$: e } = t, o = "number" == typeof e ? this._$AC(t) : (void 0 === e.el && (e.el = $e5ed8027d647799b$var$V.createElement(e.h, this.options)), e);
        if ((null === (i = this._$AH) || void 0 === i ? void 0 : i._$AD) === o) this._$AH.v(s);
        else {
            const t = new $e5ed8027d647799b$var$S(o, this), i = t.u(this.options);
            t.v(s), this.$(i), this._$AH = t;
        }
    }
    _$AC(t) {
        let i = $e5ed8027d647799b$var$E.get(t.strings);
        return void 0 === i && $e5ed8027d647799b$var$E.set(t.strings, i = new $e5ed8027d647799b$var$V(t)), i;
    }
    T(t) {
        $e5ed8027d647799b$var$c(this._$AH) || (this._$AH = [], this._$AR());
        const i = this._$AH;
        let s, e = 0;
        for (const o of t)e === i.length ? i.push(s = new $e5ed8027d647799b$var$M(this.k($e5ed8027d647799b$var$d()), this.k($e5ed8027d647799b$var$d()), this, this.options)) : s = i[e], s._$AI(o), e++;
        e < i.length && (this._$AR(s && s._$AB.nextSibling, e), i.length = e);
    }
    _$AR(t = this._$AA.nextSibling, i) {
        var s;
        for(null === (s = this._$AP) || void 0 === s || s.call(this, !1, !0, i); t && t !== this._$AB;){
            const i = t.nextSibling;
            t.remove(), t = i;
        }
    }
    setConnected(t) {
        var i;
        void 0 === this._$AM && (this._$Cp = t, null === (i = this._$AP) || void 0 === i || i.call(this, t));
    }
}
class $e5ed8027d647799b$var$R {
    constructor(t, i, s, e, o){
        this.type = 1, this._$AH = $e5ed8027d647799b$export$45b790e32b2810ee, this._$AN = void 0, this.element = t, this.name = i, this._$AM = e, this.options = o, s.length > 2 || "" !== s[0] || "" !== s[1] ? (this._$AH = Array(s.length - 1).fill(new String), this.strings = s) : this._$AH = $e5ed8027d647799b$export$45b790e32b2810ee;
    }
    get tagName() {
        return this.element.tagName;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AI(t, i = this, s, e) {
        const o = this.strings;
        let n = !1;
        if (void 0 === o) t = $e5ed8027d647799b$var$N(this, t, i, 0), n = !$e5ed8027d647799b$var$u(t) || t !== this._$AH && t !== $e5ed8027d647799b$export$9c068ae9cc5db4e8, n && (this._$AH = t);
        else {
            const e = t;
            let l, h;
            for(t = o[0], l = 0; l < o.length - 1; l++)h = $e5ed8027d647799b$var$N(this, e[s + l], i, l), h === $e5ed8027d647799b$export$9c068ae9cc5db4e8 && (h = this._$AH[l]), n || (n = !$e5ed8027d647799b$var$u(h) || h !== this._$AH[l]), h === $e5ed8027d647799b$export$45b790e32b2810ee ? t = $e5ed8027d647799b$export$45b790e32b2810ee : t !== $e5ed8027d647799b$export$45b790e32b2810ee && (t += (null != h ? h : "") + o[l + 1]), this._$AH[l] = h;
        }
        n && !e && this.j(t);
    }
    j(t) {
        t === $e5ed8027d647799b$export$45b790e32b2810ee ? this.element.removeAttribute(this.name) : this.element.setAttribute(this.name, null != t ? t : "");
    }
}
class $e5ed8027d647799b$var$k extends $e5ed8027d647799b$var$R {
    constructor(){
        super(...arguments), this.type = 3;
    }
    j(t) {
        this.element[this.name] = t === $e5ed8027d647799b$export$45b790e32b2810ee ? void 0 : t;
    }
}
const $e5ed8027d647799b$var$H = $e5ed8027d647799b$var$s ? $e5ed8027d647799b$var$s.emptyScript : "";
class $e5ed8027d647799b$var$I extends $e5ed8027d647799b$var$R {
    constructor(){
        super(...arguments), this.type = 4;
    }
    j(t) {
        t && t !== $e5ed8027d647799b$export$45b790e32b2810ee ? this.element.setAttribute(this.name, $e5ed8027d647799b$var$H) : this.element.removeAttribute(this.name);
    }
}
class $e5ed8027d647799b$var$L extends $e5ed8027d647799b$var$R {
    constructor(t, i, s, e, o){
        super(t, i, s, e, o), this.type = 5;
    }
    _$AI(t, i = this) {
        var s;
        if ((t = null !== (s = $e5ed8027d647799b$var$N(this, t, i, 0)) && void 0 !== s ? s : $e5ed8027d647799b$export$45b790e32b2810ee) === $e5ed8027d647799b$export$9c068ae9cc5db4e8) return;
        const e = this._$AH, o = t === $e5ed8027d647799b$export$45b790e32b2810ee && e !== $e5ed8027d647799b$export$45b790e32b2810ee || t.capture !== e.capture || t.once !== e.once || t.passive !== e.passive, n = t !== $e5ed8027d647799b$export$45b790e32b2810ee && (e === $e5ed8027d647799b$export$45b790e32b2810ee || o);
        o && this.element.removeEventListener(this.name, this, e), n && this.element.addEventListener(this.name, this, t), this._$AH = t;
    }
    handleEvent(t) {
        var i, s;
        "function" == typeof this._$AH ? this._$AH.call(null !== (s = null === (i = this.options) || void 0 === i ? void 0 : i.host) && void 0 !== s ? s : this.element, t) : this._$AH.handleEvent(t);
    }
}
class $e5ed8027d647799b$var$z {
    constructor(t, i, s){
        this.element = t, this.type = 6, this._$AN = void 0, this._$AM = i, this.options = s;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AI(t) {
        $e5ed8027d647799b$var$N(this, t);
    }
}
const $e5ed8027d647799b$export$8613d1ca9052b22e = {
    O: $e5ed8027d647799b$var$o,
    P: $e5ed8027d647799b$var$n,
    A: $e5ed8027d647799b$var$l,
    C: 1,
    M: $e5ed8027d647799b$var$P,
    L: $e5ed8027d647799b$var$S,
    D: $e5ed8027d647799b$var$v,
    R: $e5ed8027d647799b$var$N,
    I: $e5ed8027d647799b$var$M,
    V: $e5ed8027d647799b$var$R,
    H: $e5ed8027d647799b$var$I,
    N: $e5ed8027d647799b$var$L,
    U: $e5ed8027d647799b$var$k,
    F: $e5ed8027d647799b$var$z
}, $e5ed8027d647799b$var$j = $e5ed8027d647799b$var$i.litHtmlPolyfillSupport;
null == $e5ed8027d647799b$var$j || $e5ed8027d647799b$var$j($e5ed8027d647799b$var$V, $e5ed8027d647799b$var$M), (null !== ($e5ed8027d647799b$var$t = $e5ed8027d647799b$var$i.litHtmlVersions) && void 0 !== $e5ed8027d647799b$var$t ? $e5ed8027d647799b$var$t : $e5ed8027d647799b$var$i.litHtmlVersions = []).push("2.7.3");
const $e5ed8027d647799b$export$b3890eb0ae9dca99 = (t, i, s)=>{
    var e, o;
    const n = null !== (e = null == s ? void 0 : s.renderBefore) && void 0 !== e ? e : i;
    let l = n._$litPart$;
    if (void 0 === l) {
        const t = null !== (o = null == s ? void 0 : s.renderBefore) && void 0 !== o ? o : null;
        n._$litPart$ = l = new $e5ed8027d647799b$var$M(i.insertBefore($e5ed8027d647799b$var$d(), t), t, void 0, null != s ? s : {});
    }
    return l._$AI(t), l;
};

});

parcelRegister("lPSdM", function(module, exports) {
$parcel$export(module.exports, "css", () => (parcelRequire("4jdI8")).css);
$parcel$export(module.exports, "ReactiveElement", () => (parcelRequire("3qR54")).ReactiveElement);
$parcel$export(module.exports, "supportsAdoptingStyleSheets", () => (parcelRequire("4jdI8")).supportsAdoptingStyleSheets);
$parcel$export(module.exports, "html", () => (parcelRequire("jJTNo")).html);
$parcel$export(module.exports, "noChange", () => (parcelRequire("jJTNo")).noChange);
$parcel$export(module.exports, "nothing", () => (parcelRequire("jJTNo")).nothing);
$parcel$export(module.exports, "render", () => (parcelRequire("jJTNo")).render);

$parcel$export(module.exports, "LitElement", () => $fe586ba0757c37f7$export$3f2f9f5909897157);

var $3qR54 = parcelRequire("3qR54");

var $jJTNo = parcelRequire("jJTNo");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ var $fe586ba0757c37f7$var$l, $fe586ba0757c37f7$var$o;
const $fe586ba0757c37f7$export$8bf27daf9e8907c9 = (0, $3qR54.ReactiveElement);
class $fe586ba0757c37f7$export$3f2f9f5909897157 extends (0, $3qR54.ReactiveElement) {
    constructor(){
        super(...arguments), this.renderOptions = {
            host: this
        }, this._$Do = void 0;
    }
    createRenderRoot() {
        var t, e;
        const i = super.createRenderRoot();
        return null !== (t = (e = this.renderOptions).renderBefore) && void 0 !== t || (e.renderBefore = i.firstChild), i;
    }
    update(t) {
        const i = this.render();
        this.hasUpdated || (this.renderOptions.isConnected = this.isConnected), super.update(t), this._$Do = (0, $jJTNo.render)(i, this.renderRoot, this.renderOptions);
    }
    connectedCallback() {
        var t;
        super.connectedCallback(), null === (t = this._$Do) || void 0 === t || t.setConnected(!0);
    }
    disconnectedCallback() {
        var t;
        super.disconnectedCallback(), null === (t = this._$Do) || void 0 === t || t.setConnected(!1);
    }
    render() {
        return 0, $jJTNo.noChange;
    }
}
$fe586ba0757c37f7$export$3f2f9f5909897157.finalized = !0, $fe586ba0757c37f7$export$3f2f9f5909897157._$litElement$ = !0, null === ($fe586ba0757c37f7$var$l = globalThis.litElementHydrateSupport) || void 0 === $fe586ba0757c37f7$var$l || $fe586ba0757c37f7$var$l.call(globalThis, {
    LitElement: $fe586ba0757c37f7$export$3f2f9f5909897157
});
const $fe586ba0757c37f7$var$n = globalThis.litElementPolyfillSupport;
null == $fe586ba0757c37f7$var$n || $fe586ba0757c37f7$var$n({
    LitElement: $fe586ba0757c37f7$export$3f2f9f5909897157
});
const $fe586ba0757c37f7$export$f5c524615a7708d6 = {
    _$AK: (t, e, i)=>{
        t._$AK(e, i);
    },
    _$AL: (t)=>t._$AL
};
(null !== ($fe586ba0757c37f7$var$o = globalThis.litElementVersions) && void 0 !== $fe586ba0757c37f7$var$o ? $fe586ba0757c37f7$var$o : globalThis.litElementVersions = []).push("3.3.2");

});

parcelRegister("8FVzH", function(module, exports) {
/**
 * @license
 * Copyright 2022 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $650ed036964a13b8$export$6acf61af03e62db = !1;

});


/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var $5c96a02c592fcff1$var$extendStatics = function(d, b) {
    $5c96a02c592fcff1$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $5c96a02c592fcff1$var$extendStatics(d, b);
};
function $5c96a02c592fcff1$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $5c96a02c592fcff1$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $5c96a02c592fcff1$export$18ce0697a983be9b = function() {
    $5c96a02c592fcff1$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5c96a02c592fcff1$export$18ce0697a983be9b.apply(this, arguments);
};
function $5c96a02c592fcff1$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $5c96a02c592fcff1$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $5c96a02c592fcff1$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $5c96a02c592fcff1$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $5c96a02c592fcff1$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $5c96a02c592fcff1$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $5c96a02c592fcff1$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $5c96a02c592fcff1$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $5c96a02c592fcff1$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $5c96a02c592fcff1$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $5c96a02c592fcff1$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $5c96a02c592fcff1$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $5c96a02c592fcff1$export$45d3717a4c69092e(o, m, p);
}
function $5c96a02c592fcff1$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $5c96a02c592fcff1$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $5c96a02c592fcff1$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($5c96a02c592fcff1$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $5c96a02c592fcff1$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $5c96a02c592fcff1$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $5c96a02c592fcff1$export$10c90e4f7922046c(v) {
    return this instanceof $5c96a02c592fcff1$export$10c90e4f7922046c ? (this.v = v, this) : new $5c96a02c592fcff1$export$10c90e4f7922046c(v);
}
function $5c96a02c592fcff1$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $5c96a02c592fcff1$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $5c96a02c592fcff1$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $5c96a02c592fcff1$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $5c96a02c592fcff1$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $5c96a02c592fcff1$export$19a8beecd37a4c45 === "function" ? $5c96a02c592fcff1$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $5c96a02c592fcff1$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $5c96a02c592fcff1$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $5c96a02c592fcff1$var$ownKeys = function(o) {
    $5c96a02c592fcff1$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $5c96a02c592fcff1$var$ownKeys(o);
};
function $5c96a02c592fcff1$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $5c96a02c592fcff1$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $5c96a02c592fcff1$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $5c96a02c592fcff1$var$__setModuleDefault(result, mod);
    return result;
}
function $5c96a02c592fcff1$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $5c96a02c592fcff1$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $5c96a02c592fcff1$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $5c96a02c592fcff1$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $5c96a02c592fcff1$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $5c96a02c592fcff1$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $5c96a02c592fcff1$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $5c96a02c592fcff1$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $5c96a02c592fcff1$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $5c96a02c592fcff1$export$2e2bcd8739ae039 = {
    __extends: $5c96a02c592fcff1$export$a8ba968b8961cb8a,
    __assign: $5c96a02c592fcff1$export$18ce0697a983be9b,
    __rest: $5c96a02c592fcff1$export$3c9a16f847548506,
    __decorate: $5c96a02c592fcff1$export$29e00dfd3077644b,
    __param: $5c96a02c592fcff1$export$d5ad3fd78186038f,
    __esDecorate: $5c96a02c592fcff1$export$3a84e1ae4e97e9b0,
    __runInitializers: $5c96a02c592fcff1$export$d831c04e792af3d,
    __propKey: $5c96a02c592fcff1$export$6a2a36740a146cb8,
    __setFunctionName: $5c96a02c592fcff1$export$d1a06452d3489bc7,
    __metadata: $5c96a02c592fcff1$export$f1db080c865becb9,
    __awaiter: $5c96a02c592fcff1$export$1050f835b63b671e,
    __generator: $5c96a02c592fcff1$export$67ebef60e6f28a6,
    __createBinding: $5c96a02c592fcff1$export$45d3717a4c69092e,
    __exportStar: $5c96a02c592fcff1$export$f33643c0debef087,
    __values: $5c96a02c592fcff1$export$19a8beecd37a4c45,
    __read: $5c96a02c592fcff1$export$8d051b38c9118094,
    __spread: $5c96a02c592fcff1$export$afc72e2116322959,
    __spreadArrays: $5c96a02c592fcff1$export$6388937ca91ccae8,
    __spreadArray: $5c96a02c592fcff1$export$1216008129fb82ed,
    __await: $5c96a02c592fcff1$export$10c90e4f7922046c,
    __asyncGenerator: $5c96a02c592fcff1$export$e427f37a30a4de9b,
    __asyncDelegator: $5c96a02c592fcff1$export$bbd80228419bb833,
    __asyncValues: $5c96a02c592fcff1$export$e3b29a3d6162315f,
    __makeTemplateObject: $5c96a02c592fcff1$export$4fb47efe1390b86f,
    __importStar: $5c96a02c592fcff1$export$c21735bcef00d192,
    __importDefault: $5c96a02c592fcff1$export$da59b14a69baef04,
    __classPrivateFieldGet: $5c96a02c592fcff1$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $5c96a02c592fcff1$export$d40a35129aaff81f,
    __classPrivateFieldIn: $5c96a02c592fcff1$export$81fdc39f203e4e04,
    __addDisposableResource: $5c96a02c592fcff1$export$88ac25d8e944e405,
    __disposeResources: $5c96a02c592fcff1$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $5c96a02c592fcff1$export$889dfb5d17574b0b
};



var $d9dd8e8edd85b347$exports = {};

$parcel$export($d9dd8e8edd85b347$exports, "getWrapperEnv", () => $d9dd8e8edd85b347$export$74ecc4a9bd17e55c);
$parcel$export($d9dd8e8edd85b347$exports, "getAppEnv", () => $d9dd8e8edd85b347$export$c5f9c10e769dff78);
const $014e03efb49a85e1$export$ad0fa068a57bdc3a = {
    local: "local",
    stage: "stage",
    prestage: "prestage",
    preprod: "preprod",
    prod: "prod"
};
function $014e03efb49a85e1$export$426337ee9481be56(map) {
    return (url = window.origin)=>map[url] ?? $014e03efb49a85e1$export$ad0fa068a57bdc3a.prod;
}
const $014e03efb49a85e1$var$isEnvironment = (getEnvironment)=>(env)=>{
        return getEnvironment() === env;
    };
function $014e03efb49a85e1$export$c8619508fe34dae4(getEnvironment) {
    return function byEnvironment(envToFnMap) {
        const env = getEnvironment();
        return envToFnMap[env]();
    };
}
function $014e03efb49a85e1$export$2e2bcd8739ae039(getEnvironment) {
    return {
        isEnvironment: $014e03efb49a85e1$var$isEnvironment(getEnvironment),
        byEnvironment: $014e03efb49a85e1$export$c8619508fe34dae4(getEnvironment)
    };
}


const $d9dd8e8edd85b347$export$74ecc4a9bd17e55c = (0, $014e03efb49a85e1$export$426337ee9481be56)({
    "https://localhost.corp.adobe.com:8080": (0, $014e03efb49a85e1$export$ad0fa068a57bdc3a).local,
    "https://auth-light-sample.identity-stage.adobe.com": (0, $014e03efb49a85e1$export$ad0fa068a57bdc3a).stage,
    "https://auth-light-sample.identity-prestage.adobe.com": (0, $014e03efb49a85e1$export$ad0fa068a57bdc3a).prestage,
    "https://auth-light-sample.identity-preprod.adobe.com": (0, $014e03efb49a85e1$export$ad0fa068a57bdc3a).preprod
});
const $d9dd8e8edd85b347$export$c5f9c10e769dff78 = (0, $014e03efb49a85e1$export$426337ee9481be56)({
    "https://localhost.corp.adobe.com:25000": (0, $014e03efb49a85e1$export$ad0fa068a57bdc3a).local,
    "https://auth-light.identity-stage.adobe.com": (0, $014e03efb49a85e1$export$ad0fa068a57bdc3a).stage,
    "https://auth-light.identity-prestage.adobe.com": (0, $014e03efb49a85e1$export$ad0fa068a57bdc3a).stage,
    "https://auth-light.identity-preprod.adobe.com": (0, $014e03efb49a85e1$export$ad0fa068a57bdc3a).prod
});



const $5b98751366a4bfab$export$85b027bf1c0c3c10 = {
    undefined: "undefined",
    critical: "critical",
    generic: "generic",
    unrecoverable: "unrecoverable"
};
function $5b98751366a4bfab$var$toStringError(error) {
    if (error instanceof $5b98751366a4bfab$export$5949942ba2a7c0e2) return error.toString();
    if (error instanceof Error) {
        const message = error.message ? `: ${error.message}` : "";
        return error.name + message;
    }
    return "";
}
class $5b98751366a4bfab$export$5949942ba2a7c0e2 extends Error {
    toJSON() {
        return {
            name: this.name,
            message: this.message,
            stack: this.stack
        };
    }
    toString() {
        const error = `${this.name}: ${this.message}`;
        const originalErrorString = $5b98751366a4bfab$var$toStringError(this.originalError).replaceAll("\n", "\n	");
        return `${error}\n\t<- ${originalErrorString}`;
    }
    get name() {
        return this.type;
    }
    get stack() {
        return this.originalError?.stack ?? this.stack;
    }
    static extendError(sentryError, originalError) {
        if (originalError && originalError instanceof Error) sentryError.originalError = originalError;
        return sentryError;
    }
    static generic(originalError) {
        const error = new $5b98751366a4bfab$export$7d465be8efa67280();
        return $5b98751366a4bfab$export$5949942ba2a7c0e2.extendError(error, originalError);
    }
    static critical(causeMessage, originalError) {
        const error = new $5b98751366a4bfab$export$4b42a7a78fede561(causeMessage);
        return $5b98751366a4bfab$export$5949942ba2a7c0e2.extendError(error, originalError);
    }
    static unrecoverable(causeMessage, originalError) {
        const error = new $5b98751366a4bfab$export$58a7ae465253b2fa(causeMessage);
        return $5b98751366a4bfab$export$5949942ba2a7c0e2.extendError(error, originalError);
    }
    constructor(...args){
        super(...args);
        this.type = $5b98751366a4bfab$export$85b027bf1c0c3c10.undefined;
        this.cause = "";
    }
}
class $5b98751366a4bfab$export$7d465be8efa67280 extends $5b98751366a4bfab$export$5949942ba2a7c0e2 {
    constructor(...args){
        super(...args);
        this.type = $5b98751366a4bfab$export$85b027bf1c0c3c10.generic;
    }
}
class $5b98751366a4bfab$export$4b42a7a78fede561 extends $5b98751366a4bfab$export$5949942ba2a7c0e2 {
    constructor(...args){
        super(...args);
        this.type = $5b98751366a4bfab$export$85b027bf1c0c3c10.critical;
    }
}
class $5b98751366a4bfab$export$58a7ae465253b2fa extends $5b98751366a4bfab$export$5949942ba2a7c0e2 {
    constructor(...args){
        super(...args);
        this.type = $5b98751366a4bfab$export$85b027bf1c0c3c10.unrecoverable;
    }
}
function $5b98751366a4bfab$export$f555a51577ce160(input) {
    if (input instanceof $5b98751366a4bfab$export$5949942ba2a7c0e2) return input;
    if (input instanceof Error) return $5b98751366a4bfab$export$5949942ba2a7c0e2.generic(input);
    return $5b98751366a4bfab$export$5949942ba2a7c0e2.generic(new Error(String(input)));
}



function $347978f84fbb7aa9$export$38cf933889b055d9(eventStr) {
    const prefixLength = eventStr.indexOf("-");
    const metaDataLength = eventStr.indexOf(":");
    const event = eventStr.substring(0, prefixLength);
    const side = eventStr.substring(prefixLength + 1, metaDataLength);
    const data = eventStr.substring(metaDataLength + 1);
    return {
        event: event,
        side: side,
        data: data
    };
}
class $347978f84fbb7aa9$export$d61e24a684f9e51 {
    constructor({ name: name, side: side, data: data }){
        this.name = name;
        this.side = side;
        this.data = data;
    }
    setData(data) {
        if (data) return $347978f84fbb7aa9$export$d61e24a684f9e51.create({
            name: this.name,
            side: this.side,
            data: data
        });
        else return this;
    }
    compareTo(event) {
        return this.name === event.name && this.side === event.side;
    }
    of(base) {
        return this.compareTo(base);
    }
    toString() {
        return JSON.stringify(this);
    }
    static fromString(eventStr) {
        if (typeof eventStr !== "string") throw new TypeError("Event: Event couldn't be created. Invalid value.");
        const parse = JSON.parse(eventStr);
        if (parse && Object.prototype.hasOwnProperty.call(parse, "side") && Object.prototype.hasOwnProperty.call(parse, "name")) return new $347978f84fbb7aa9$export$d61e24a684f9e51(JSON.parse(eventStr));
        else throw new TypeError("Event: Event incorrectly formatted. Missing side or name.");
    }
    static parse(eventStr, assertedEvent) {
        const event = this.fromString(eventStr);
        if (event.compareTo(assertedEvent)) return event;
        else return null;
    }
    static create(params) {
        return new $347978f84fbb7aa9$export$d61e24a684f9e51(params);
    }
}
const $347978f84fbb7aa9$export$9071af2ede914ef4 = $347978f84fbb7aa9$export$d61e24a684f9e51.create({
    name: "init",
    side: "app"
});
const $347978f84fbb7aa9$export$6a03e30751fc8429 = $347978f84fbb7aa9$export$d61e24a684f9e51.create({
    name: "response",
    side: "wrapper",
    data: {}
});
const $347978f84fbb7aa9$export$91f51023bb6bac2f = $347978f84fbb7aa9$export$d61e24a684f9e51.create({
    name: "complete",
    side: "app"
});
const $347978f84fbb7aa9$export$c4a23014fbd7877d = $347978f84fbb7aa9$export$d61e24a684f9e51.create({
    name: "error",
    side: "app",
    data: (0, $5b98751366a4bfab$export$5949942ba2a7c0e2).unrecoverable("Unknown error.")
});
const $347978f84fbb7aa9$export$47edff89ee5eefdb = $347978f84fbb7aa9$export$d61e24a684f9e51.create({
    name: "open-popup",
    side: "app",
    data: ""
});
const $347978f84fbb7aa9$export$b9a2c15ca74dee47 = $347978f84fbb7aa9$export$d61e24a684f9e51.create({
    name: "on-modal-open",
    side: "proxy",
    data: {
        dimensions: {
            height: 550,
            width: 400
        },
        reason: "unknown"
    }
});
const $347978f84fbb7aa9$export$4518ed92bbb25c89 = $347978f84fbb7aa9$export$d61e24a684f9e51.create({
    name: "on-modal-close",
    side: "proxy"
});
const $347978f84fbb7aa9$export$6fdc11b9e9b0a645 = $347978f84fbb7aa9$export$d61e24a684f9e51.create({
    name: "open-modal-complete",
    side: "wrapper"
});
const $347978f84fbb7aa9$export$6ddaf5c7fdb615c5 = $347978f84fbb7aa9$export$d61e24a684f9e51.create({
    name: "open-popup-complete",
    side: "wrapper"
});
const $347978f84fbb7aa9$export$43a7920667fb5990 = $347978f84fbb7aa9$export$d61e24a684f9e51.create({
    name: "open-popup-blocked",
    side: "wrapper"
});
const $347978f84fbb7aa9$export$aa36cdda8cc1d9c0 = $347978f84fbb7aa9$export$d61e24a684f9e51.create({
    name: "open-popup-error",
    side: "popup",
    data: ""
});
const $347978f84fbb7aa9$export$9b94066e3b15bd87 = $347978f84fbb7aa9$export$d61e24a684f9e51.create({
    name: "query-state",
    side: "popup",
    data: ""
});
function $347978f84fbb7aa9$export$f28ca1a95bdaacaa(targetOrigin, targetWindow = window.parent) {
    return new Promise((resolve, reject)=>{
        if (!targetOrigin) reject((0, $5b98751366a4bfab$export$5949942ba2a7c0e2).unrecoverable("Invalid target origin."));
        // Send Init event and second port to establish connection
        const channel = new MessageChannel();
        targetWindow.postMessage($347978f84fbb7aa9$export$9071af2ede914ef4.toString(), targetOrigin, [
            channel.port2
        ]);
        // Wait for ResponseEvent from Wrapper
        channel.port1.onmessage = function(e) {
            const response = $347978f84fbb7aa9$export$d61e24a684f9e51.parse(e.data, $347978f84fbb7aa9$export$6a03e30751fc8429);
            if (response) {
                channel.port1.postMessage($347978f84fbb7aa9$export$91f51023bb6bac2f.toString());
                // Resolve with Wrapper data and port
                resolve({
                    port: channel.port1,
                    channel: channel,
                    state: response.data
                });
            } else reject($347978f84fbb7aa9$export$c4a23014fbd7877d.setData((0, $5b98751366a4bfab$export$5949942ba2a7c0e2).unrecoverable("Wrong wrapper response.")));
        };
    });
}
function $347978f84fbb7aa9$export$9d816695ec3452c1(allowedOrigin) {
    return new Promise((resolve, reject)=>{
        window.addEventListener("message", function listener(e) {
            if (e.origin !== allowedOrigin) return;
            const event = $347978f84fbb7aa9$export$d61e24a684f9e51.fromString(e.data);
            if (event.of($347978f84fbb7aa9$export$9071af2ede914ef4)) resolve(e.ports[0]);
            if (event.of($347978f84fbb7aa9$export$c4a23014fbd7877d)) reject(event);
            window.removeEventListener("message", listener);
        });
    });
}
function $347978f84fbb7aa9$export$a08fb5cc915b7487(port, state) {
    return new Promise((resolve, reject)=>{
        // Wait for Complete event
        port.onmessage = function(e) {
            const event = $347978f84fbb7aa9$export$d61e24a684f9e51.parse(e.data, $347978f84fbb7aa9$export$91f51023bb6bac2f);
            if (event) resolve(port);
            else reject($347978f84fbb7aa9$export$c4a23014fbd7877d.setData((0, $5b98751366a4bfab$export$5949942ba2a7c0e2).unrecoverable("Invalid Sentry reponse to the connection.")));
        };
        // Send Response event
        $347978f84fbb7aa9$export$6a03e30751fc8429.data = state;
        port.postMessage($347978f84fbb7aa9$export$6a03e30751fc8429.toString());
    });
}
function $347978f84fbb7aa9$export$5a3c9ae1fa6d7e61(port) {
    const eventEmitter = new $347978f84fbb7aa9$export$4fae95256245c8c0();
    port.onmessage = function(event) {
        eventEmitter.broadcast($347978f84fbb7aa9$export$d61e24a684f9e51.fromString(event.data));
    };
    port.onmessageerror = function() {
        eventEmitter.broadcast($347978f84fbb7aa9$export$c4a23014fbd7877d.setData((0, $5b98751366a4bfab$export$5949942ba2a7c0e2).unrecoverable("Port message error.")));
    };
    window.addEventListener("storage", ({ key: key, newValue: newValue })=>{
        try {
            if (key === "popupEvent" && newValue) {
                const event = $347978f84fbb7aa9$export$d61e24a684f9e51.fromString(newValue);
                if (event.of($347978f84fbb7aa9$export$9b94066e3b15bd87)) {
                    const returnEvent = $347978f84fbb7aa9$export$d61e24a684f9e51.fromString(event.data);
                    eventEmitter.broadcast(returnEvent);
                }
            }
        } catch (e) {
            console.error(e);
        } finally{
            localStorage.removeItem("popupEvent");
        }
    });
    const eventScheduler = new $347978f84fbb7aa9$export$e0c335d02293e8fa(eventEmitter);
    return function() {
        return eventScheduler;
    };
}
class $347978f84fbb7aa9$export$4fae95256245c8c0 {
    get numListeners() {
        return this.listeners.size;
    }
    add(listener) {
        this.listeners.add(listener);
    }
    remove(listener) {
        this.listeners.delete(listener);
    }
    broadcast(event) {
        this.listeners.forEach((listener)=>{
            listener.emit(event);
        });
    }
    constructor(){
        this.listeners = new Set();
    }
}
class $347978f84fbb7aa9$export$e0c335d02293e8fa {
    constructor(emitter){
        this.emitter = emitter;
    }
    subscribe(fn) {
        const listener = new $347978f84fbb7aa9$export$3291343375ee8b92(fn);
        this.emitter.add(listener);
        return ()=>{
            this.emitter.remove(listener);
        };
    }
    once(fn) {
        let disposer;
        const promise = new Promise((res)=>{
            disposer = this.subscribe((event)=>res(event));
        });
        promise.catch(()=>disposer());
        if (fn) return promise.then((event)=>fn(event)).then(()=>disposer());
        else return promise;
    }
    listenFor(listenedEvent) {
        return new Promise((res, rej)=>{
            const disposer = this.subscribe((event)=>{
                if (listenedEvent.compareTo(event)) {
                    res(event);
                    disposer();
                }
            });
        });
    }
}
class $347978f84fbb7aa9$export$3291343375ee8b92 {
    constructor(listener){
        this.listener = listener;
    }
    emit(event) {
        this.listener(event);
    }
}
function $347978f84fbb7aa9$export$c9526fa4526c2c60(port) {
    return (event)=>(data)=>{
            event.data = data;
            port.postMessage(event.toString());
            return null;
        };
}



function $0e00f03e701b58f8$export$fe2e61603b61130d(getEnv, clientId, relay = "", name = "default") {
    const env = (0, $014e03efb49a85e1$export$c8619508fe34dae4)(getEnv);
    const endpoint = env({
        [(0, $014e03efb49a85e1$export$ad0fa068a57bdc3a).local]: ()=>"https://localhost.corp.adobe.com:8081/signin",
        [(0, $014e03efb49a85e1$export$ad0fa068a57bdc3a).stage]: ()=>"https://auth-stg1.services.adobe.com/signin/v1/audit",
        [(0, $014e03efb49a85e1$export$ad0fa068a57bdc3a).prestage]: ()=>"https://auth-stg1.services.adobe.com/signin/v1/audit",
        [(0, $014e03efb49a85e1$export$ad0fa068a57bdc3a).preprod]: ()=>"https://auth.services.adobe.com/signin/v1/audit",
        [(0, $014e03efb49a85e1$export$ad0fa068a57bdc3a).prod]: ()=>"https://auth.services.adobe.com/signin/v1/audit"
    });
    const envName = env({
        [(0, $014e03efb49a85e1$export$ad0fa068a57bdc3a).local]: ()=>"susi-light-local",
        [(0, $014e03efb49a85e1$export$ad0fa068a57bdc3a).stage]: ()=>"susi-light-stage",
        [(0, $014e03efb49a85e1$export$ad0fa068a57bdc3a).prestage]: ()=>"susi-light-prestage",
        [(0, $014e03efb49a85e1$export$ad0fa068a57bdc3a).preprod]: ()=>"susi-light-preprod",
        [(0, $014e03efb49a85e1$export$ad0fa068a57bdc3a).prod]: ()=>"susi-light-prod"
    });
    return function logger(message) {
        return fetch(endpoint, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "X-IMS-CLIENTID": clientId,
                "X-DEBUG-ID": relay
            },
            body: JSON.stringify({
                name: name,
                envName: envName,
                clientId: clientId,
                message: message
            })
        }).catch((e)=>{});
    };
}


var $2506848516995d9e$exports = {};

$parcel$export($2506848516995d9e$exports, "getApiUrl", () => $2506848516995d9e$export$1b98eaf73d37f034);
$parcel$export($2506848516995d9e$exports, "getFederatedUrl", () => $2506848516995d9e$export$f952767a492cb9b4);
$parcel$export($2506848516995d9e$exports, "getAuthServicesUrl", () => $2506848516995d9e$export$f59a4c477164a56a);
$parcel$export($2506848516995d9e$exports, "getAdobeidServicesUrl", () => $2506848516995d9e$export$b4f94fd2634bbbc0);
$parcel$export($2506848516995d9e$exports, "getAppUrl", () => $2506848516995d9e$export$7086db7f8cfa1126);
$parcel$export($2506848516995d9e$exports, "getPopupUrl", () => $2506848516995d9e$export$fb180f11d351b294);
$parcel$export($2506848516995d9e$exports, "sentryUrl", () => $2506848516995d9e$export$c0be0235fa958cd7);
$parcel$export($2506848516995d9e$exports, "create", () => $2506848516995d9e$export$185802fd694ee1f5);

function $2506848516995d9e$export$1b98eaf73d37f034(getEnvironment) {
    return ()=>(0, $014e03efb49a85e1$export$c8619508fe34dae4)(getEnvironment)({
            [(0, $014e03efb49a85e1$export$ad0fa068a57bdc3a).local]: ()=>"https://ims-na1-stg1.adobelogin.com",
            [(0, $014e03efb49a85e1$export$ad0fa068a57bdc3a).stage]: ()=>"https://ims-na1-stg1.adobelogin.com",
            [(0, $014e03efb49a85e1$export$ad0fa068a57bdc3a).prestage]: ()=>"https://ims-na1-stg1.adobelogin.com",
            [(0, $014e03efb49a85e1$export$ad0fa068a57bdc3a).preprod]: ()=>"https://ims-na1.adobelogin.com",
            [(0, $014e03efb49a85e1$export$ad0fa068a57bdc3a).prod]: ()=>"https://ims-na1.adobelogin.com"
        });
}
function $2506848516995d9e$export$f952767a492cb9b4(getEnvironment) {
    return ()=>(0, $014e03efb49a85e1$export$c8619508fe34dae4)(getEnvironment)({
            [(0, $014e03efb49a85e1$export$ad0fa068a57bdc3a).local]: ()=>"https://federatedid-na1-stg1.services.adobe.com",
            [(0, $014e03efb49a85e1$export$ad0fa068a57bdc3a).stage]: ()=>"https://federatedid-na1-stg1.services.adobe.com",
            [(0, $014e03efb49a85e1$export$ad0fa068a57bdc3a).prestage]: ()=>"https://federatedid-na1-stg1.services.adobe.com",
            [(0, $014e03efb49a85e1$export$ad0fa068a57bdc3a).preprod]: ()=>"https://federatedid-na1.services.adobe.com",
            [(0, $014e03efb49a85e1$export$ad0fa068a57bdc3a).prod]: ()=>"https://federatedid-na1.services.adobe.com"
        });
}
function $2506848516995d9e$export$f59a4c477164a56a(getEnvironment) {
    return ()=>(0, $014e03efb49a85e1$export$c8619508fe34dae4)(getEnvironment)({
            [(0, $014e03efb49a85e1$export$ad0fa068a57bdc3a).local]: ()=>"http://localhost.corp.adobe.com:3000",
            [(0, $014e03efb49a85e1$export$ad0fa068a57bdc3a).stage]: ()=>"https://auth-stg1.services.adobe.com",
            [(0, $014e03efb49a85e1$export$ad0fa068a57bdc3a).prestage]: ()=>"https://auth-stg1.services.adobe.com",
            [(0, $014e03efb49a85e1$export$ad0fa068a57bdc3a).preprod]: ()=>"https://auth.services.adobe.com",
            [(0, $014e03efb49a85e1$export$ad0fa068a57bdc3a).prod]: ()=>"https://auth.services.adobe.com"
        });
}
function $2506848516995d9e$export$b4f94fd2634bbbc0(getEnvironment) {
    return ()=>(0, $014e03efb49a85e1$export$c8619508fe34dae4)(getEnvironment)({
            [(0, $014e03efb49a85e1$export$ad0fa068a57bdc3a).local]: ()=>"http://localhost.corp.adobe.com:3000",
            [(0, $014e03efb49a85e1$export$ad0fa068a57bdc3a).stage]: ()=>" https://adobeid-na1-stg1.services.adobe.com",
            [(0, $014e03efb49a85e1$export$ad0fa068a57bdc3a).prestage]: ()=>"https://adobeid-na1-stg1.services.adobe.com",
            [(0, $014e03efb49a85e1$export$ad0fa068a57bdc3a).preprod]: ()=>"https://adobeid-na1.services.adobe.com",
            [(0, $014e03efb49a85e1$export$ad0fa068a57bdc3a).prod]: ()=>"https://adobeid-na1.services.adobe.com"
        });
}
function $2506848516995d9e$export$7086db7f8cfa1126(getEnvironment) {
    return ()=>(0, $014e03efb49a85e1$export$c8619508fe34dae4)(getEnvironment)({
            [(0, $014e03efb49a85e1$export$ad0fa068a57bdc3a).local]: ()=>"https://localhost.corp.adobe.com:25000",
            [(0, $014e03efb49a85e1$export$ad0fa068a57bdc3a).stage]: ()=>"https://auth-light.identity-stage.adobe.com",
            [(0, $014e03efb49a85e1$export$ad0fa068a57bdc3a).prestage]: ()=>"https://auth-light.identity-prestage.adobe.com",
            [(0, $014e03efb49a85e1$export$ad0fa068a57bdc3a).preprod]: ()=>"https://auth-light.identity-preprod.adobe.com",
            [(0, $014e03efb49a85e1$export$ad0fa068a57bdc3a).prod]: ()=>"https://auth-light.identity.adobe.com"
        });
}
function $2506848516995d9e$export$fb180f11d351b294(getEnvironment) {
    return ()=>(0, $014e03efb49a85e1$export$c8619508fe34dae4)(getEnvironment)({
            [(0, $014e03efb49a85e1$export$ad0fa068a57bdc3a).local]: ()=>"https://localhost.corp.adobe.com:25000/wrapper-popup-helper/index.html",
            [(0, $014e03efb49a85e1$export$ad0fa068a57bdc3a).stage]: ()=>"https://auth-light.identity-stage.adobe.com/wrapper-popup-helper/index.html",
            [(0, $014e03efb49a85e1$export$ad0fa068a57bdc3a).prestage]: ()=>"https://auth-light.identity-prestage.adobe.com/wrapper-popup-helper/index.html",
            [(0, $014e03efb49a85e1$export$ad0fa068a57bdc3a).preprod]: ()=>"https://auth-light.identity-preprod.adobe.com/wrapper-popup-helper/index.html",
            [(0, $014e03efb49a85e1$export$ad0fa068a57bdc3a).prod]: ()=>"https://auth-light.identity.adobe.com/wrapper-popup-helper/index.html"
        });
}
const $2506848516995d9e$export$c0be0235fa958cd7 = (getEnvironment, forceStage = false)=>function sentryUrl(variant) {
        const envUrl = $2506848516995d9e$export$7086db7f8cfa1126(forceStage ? ()=>(0, $014e03efb49a85e1$export$ad0fa068a57bdc3a).stage : getEnvironment)();
        const url = new URL(envUrl || "");
        url.hash = variant;
        return url;
    };
function $2506848516995d9e$export$185802fd694ee1f5(getEnvironment) {
    return {
        getApiUrl: $2506848516995d9e$export$1b98eaf73d37f034(getEnvironment),
        getAppUrl: $2506848516995d9e$export$7086db7f8cfa1126(getEnvironment),
        getFederatedUrl: $2506848516995d9e$export$f952767a492cb9b4(getEnvironment),
        getAuthServicesUrl: $2506848516995d9e$export$f59a4c477164a56a(getEnvironment),
        getAdobeidServicesUrl: $2506848516995d9e$export$b4f94fd2634bbbc0(getEnvironment),
        getPopupUrl: $2506848516995d9e$export$fb180f11d351b294(getEnvironment),
        sentryUrl: $2506848516995d9e$export$c0be0235fa958cd7(getEnvironment)
    };
}




var $a31ad5627cd62068$exports = {};
"use strict";
Object.defineProperty($a31ad5627cd62068$exports, "__esModule", {
    value: true
});
$a31ad5627cd62068$exports.byEnvironment = $a31ad5627cd62068$exports.environmentMapper = $a31ad5627cd62068$exports.ENVIRONMENTS = void 0;
$a31ad5627cd62068$exports.ENVIRONMENTS = {
    local: "local",
    stage: "stage",
    prestage: "prestage",
    preprod: "preprod",
    prod: "prod"
};
function $a31ad5627cd62068$var$environmentMapper(map) {
    return (url = window.origin)=>{
        var _a;
        return (_a = map[url]) !== null && _a !== void 0 ? _a : $a31ad5627cd62068$exports.ENVIRONMENTS.prod;
    };
}
$a31ad5627cd62068$exports.environmentMapper = $a31ad5627cd62068$var$environmentMapper;
const $a31ad5627cd62068$var$isEnvironment = (getEnvironment)=>(env)=>{
        return getEnvironment() === env;
    };
function $a31ad5627cd62068$var$byEnvironment(getEnvironment) {
    return function byEnvironment(envToFnMap) {
        const env = getEnvironment();
        return envToFnMap[env]();
    };
}
$a31ad5627cd62068$exports.byEnvironment = $a31ad5627cd62068$var$byEnvironment;
function $a31ad5627cd62068$var$default_1(getEnvironment) {
    return {
        isEnvironment: $a31ad5627cd62068$var$isEnvironment(getEnvironment),
        byEnvironment: $a31ad5627cd62068$var$byEnvironment(getEnvironment)
    };
}
$a31ad5627cd62068$exports.default = $a31ad5627cd62068$var$default_1;


parcelRequire("800sp");
var $4jdI8 = parcelRequire("4jdI8");
var $jJTNo = parcelRequire("jJTNo");
var $lPSdM = parcelRequire("lPSdM");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $07706bf0c990b886$export$da64fc29f17f9d0e = (e)=>(n)=>"function" == typeof n ? ((e, n)=>(customElements.define(e, n), n))(e, n) : ((e, n)=>{
            const { kind: t, elements: s } = n;
            return {
                kind: t,
                elements: s,
                finisher (n) {
                    customElements.define(e, n);
                }
            };
        })(e, n);


/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $b2fdcbe153c88f81$var$i = (i, e)=>"method" === e.kind && e.descriptor && !("value" in e.descriptor) ? {
        ...e,
        finisher (n) {
            n.createProperty(e.key, i);
        }
    } : {
        kind: "field",
        key: Symbol(),
        placement: "own",
        descriptor: {},
        originalKey: e.key,
        initializer () {
            "function" == typeof e.initializer && (this[e.key] = e.initializer.call(this));
        },
        finisher (n) {
            n.createProperty(e.key, i);
        }
    };
function $b2fdcbe153c88f81$export$d541bacb2bda4494(e) {
    return (n, t)=>void 0 !== t ? ((i, e, n)=>{
            e.constructor.createProperty(n, i);
        })(e, n, t) : $b2fdcbe153c88f81$var$i(e, n);
}



/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $7162e77b40ffab5c$export$ca000e230c0caa3e(t) {
    return (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        ...t,
        state: !0
    });
}


/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $15c76e2f7983b497$export$29fd0ed4087278b5 = (e, t, o)=>{
    Object.defineProperty(t, o, e);
}, $15c76e2f7983b497$export$18eb0154d0069a01 = (e, t)=>({
        kind: "method",
        placement: "prototype",
        key: t.key,
        descriptor: e
    }), $15c76e2f7983b497$export$757d561a932dc1cb = ({ finisher: e, descriptor: t })=>(o, n)=>{
        var r;
        if (void 0 === n) {
            const n = null !== (r = o.originalKey) && void 0 !== r ? r : o.key, i = null != t ? {
                kind: "method",
                placement: "prototype",
                key: n,
                descriptor: t(o.key)
            } : {
                ...o,
                key: n
            };
            return null != e && (i.finisher = function(t) {
                e(t, n);
            }), i;
        }
        {
            const r = o.constructor;
            void 0 !== t && Object.defineProperty(o, n, t(n)), null == e || e(r, n);
        }
    };


/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $e5c3d47edfef3b02$export$b2b799818fbabcf3(e) {
    return (0, $15c76e2f7983b497$export$757d561a932dc1cb)({
        finisher: (r, t)=>{
            Object.assign(r.prototype[t], e);
        }
    });
}



/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $10a410638b7df95b$export$2fa187e846a241c4(i, n) {
    return (0, $15c76e2f7983b497$export$757d561a932dc1cb)({
        descriptor: (o)=>{
            const t = {
                get () {
                    var o, n;
                    return null !== (n = null === (o = this.renderRoot) || void 0 === o ? void 0 : o.querySelector(i)) && void 0 !== n ? n : null;
                },
                enumerable: !0,
                configurable: !0
            };
            if (n) {
                const n = "symbol" == typeof o ? Symbol() : "__" + o;
                t.get = function() {
                    var o, t;
                    return void 0 === this[n] && (this[n] = null !== (t = null === (o = this.renderRoot) || void 0 === o ? void 0 : o.querySelector(i)) && void 0 !== t ? t : null), this[n];
                };
            }
            return t;
        }
    });
}



/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $24ba95ebfbdcf6b8$export$dcd0d083aa86c355(e) {
    return (0, $15c76e2f7983b497$export$757d561a932dc1cb)({
        descriptor: (r)=>({
                get () {
                    var r, o;
                    return null !== (o = null === (r = this.renderRoot) || void 0 === r ? void 0 : r.querySelectorAll(e)) && void 0 !== o ? o : [];
                },
                enumerable: !0,
                configurable: !0
            })
    });
}



/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $1f45ba04a1effcd1$export$163dfc35cc43f240(e) {
    return (0, $15c76e2f7983b497$export$757d561a932dc1cb)({
        descriptor: (r)=>({
                async get () {
                    var r;
                    return await this.updateComplete, null === (r = this.renderRoot) || void 0 === r ? void 0 : r.querySelector(e);
                },
                enumerable: !0,
                configurable: !0
            })
    });
}



/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ var $43ca3aec390b0561$var$n;
const $43ca3aec390b0561$var$e = null != (null === ($43ca3aec390b0561$var$n = window.HTMLSlotElement) || void 0 === $43ca3aec390b0561$var$n ? void 0 : $43ca3aec390b0561$var$n.prototype.assignedElements) ? (o, n)=>o.assignedElements(n) : (o, n)=>o.assignedNodes(n).filter((o)=>o.nodeType === Node.ELEMENT_NODE);
function $43ca3aec390b0561$export$4682af2d9ee91415(n) {
    const { slot: l, selector: t } = null != n ? n : {};
    return (0, $15c76e2f7983b497$export$757d561a932dc1cb)({
        descriptor: (o)=>({
                get () {
                    var o;
                    const r = "slot" + (l ? `[name=${l}]` : ":not([name])"), i = null === (o = this.renderRoot) || void 0 === o ? void 0 : o.querySelector(r), s = null != i ? $43ca3aec390b0561$var$e(i, n) : [];
                    return t ? s.filter((o)=>o.matches(t)) : s;
                },
                enumerable: !0,
                configurable: !0
            })
    });
}




/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $965e44d5bf066bc5$export$1bdbe53f9df1b8(o, n, r) {
    let l, s = o;
    return "object" == typeof o ? (s = o.slot, l = o) : l = {
        flatten: n
    }, r ? (0, $43ca3aec390b0561$export$4682af2d9ee91415)({
        slot: s,
        flatten: n,
        selector: r
    }) : (0, $15c76e2f7983b497$export$757d561a932dc1cb)({
        descriptor: (e)=>({
                get () {
                    var e, t;
                    const o = "slot" + (s ? `[name=${s}]` : ":not([name])"), n = null === (e = this.renderRoot) || void 0 === e ? void 0 : e.querySelector(o);
                    return null !== (t = null == n ? void 0 : n.assignedNodes(l)) && void 0 !== t ? t : [];
                },
                enumerable: !0,
                configurable: !0
            })
    });
}





var $jJTNo = parcelRequire("jJTNo");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $3baabda811939da5$export$9ba3b3f20a85bfa = {
    ATTRIBUTE: 1,
    CHILD: 2,
    PROPERTY: 3,
    BOOLEAN_ATTRIBUTE: 4,
    EVENT: 5,
    ELEMENT: 6
}, $3baabda811939da5$export$99b43ad1ed32e735 = (t)=>(...e)=>({
            _$litDirective$: t,
            values: e
        });
class $3baabda811939da5$export$befdefbdce210f91 {
    constructor(t){}
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AT(t, e, i) {
        this._$Ct = t, this._$AM = e, this._$Ci = i;
    }
    _$AS(t, e) {
        return this.update(t, e);
    }
    update(t, e) {
        return this.render(...e);
    }
}


/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $0e5c059fc79abe53$export$56cc687933817664 = (0, $3baabda811939da5$export$99b43ad1ed32e735)(class extends (0, $3baabda811939da5$export$befdefbdce210f91) {
    constructor(t){
        var i;
        if (super(t), t.type !== (0, $3baabda811939da5$export$9ba3b3f20a85bfa).ATTRIBUTE || "class" !== t.name || (null === (i = t.strings) || void 0 === i ? void 0 : i.length) > 2) throw Error("`classMap()` can only be used in the `class` attribute and must be the only part in the attribute.");
    }
    render(t) {
        return " " + Object.keys(t).filter((i)=>t[i]).join(" ") + " ";
    }
    update(i, [s]) {
        var r, o;
        if (void 0 === this.it) {
            this.it = new Set, void 0 !== i.strings && (this.nt = new Set(i.strings.join(" ").split(/\s/).filter((t)=>"" !== t)));
            for(const t in s)s[t] && !(null === (r = this.nt) || void 0 === r ? void 0 : r.has(t)) && this.it.add(t);
            return this.render(s);
        }
        const e = i.element.classList;
        this.it.forEach((t)=>{
            t in s || (e.remove(t), this.it.delete(t));
        });
        for(const t in s){
            const i = !!s[t];
            i === this.it.has(t) || (null === (o = this.nt) || void 0 === o ? void 0 : o.has(t)) || (i ? (e.add(t), this.it.add(t)) : (e.remove(t), this.it.delete(t)));
        }
        return 0, $jJTNo.noChange;
    }
});




function $db3100f4fad4ddc1$export$83981d14e606a61f({ url: url, title: title, w: w, h: h }) {
    const dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : window.screenX;
    const dualScreenTop = window.screenTop !== undefined ? window.screenTop : window.screenY;
    const width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
    const height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;
    const left = (width - w) / 2 + dualScreenLeft;
    const top = (height - h) / 2 + dualScreenTop;
    const openedWindow = window.open(url, title, `
    menubar=0,
    resizable=0,
    scrollbars=no,
    width=${w}, 
    height=${h}, 
    top=${top}, 
    left=${left}
    `);
    return openedWindow;
}


const $83a01ffb6406d320$export$83d89fbfd8236492 = "1.0.8";
const $83a01ffb6406d320$export$3f8fe6489e95757d = ":1fff46b";
const $83a01ffb6406d320$export$126f857cb595c8fa = "1790261823349";


function $466d3fc07826c612$var$getWrapperEnv(forceStage = false) {
    return forceStage ? ()=>(0, $a31ad5627cd62068$exports.ENVIRONMENTS).stage : (0, $d9dd8e8edd85b347$exports).getWrapperEnv;
}
function $466d3fc07826c612$var$getAppUrl(forceStage = false) {
    const { getAppUrl: getAppUrl } = (0, $2506848516995d9e$exports).create($466d3fc07826c612$var$getWrapperEnv(forceStage));
    return getAppUrl();
}
const { sentryUrl: $466d3fc07826c612$var$sentryUrl } = (0, $2506848516995d9e$exports);
window.__sentry__ = {
    info: {
        version: $83a01ffb6406d320$export$83d89fbfd8236492,
        build: $83a01ffb6406d320$export$3f8fe6489e95757d,
        buildTime: $83a01ffb6406d320$export$126f857cb595c8fa
    }
};
let $466d3fc07826c612$var$Sentry = class Sentry extends (0, $lPSdM.LitElement) {
    static #_ = this.styles = (0, $4jdI8.css)`
    s :host {
      display: block;
    }

    :host,
    section,
    iframe {
      width: 100%;
      height: 100%;
      background: transparent;
      color-scheme: normal;
      border: 0;
    }

    #sentry-container.modal-mode {
      display: none;
    }

    #sentry-container.modal {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: transparent;
      z-index: 9999;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .modal #sentry {
      box-sizing: border-box;
      padding: 40px;
      border-radius: 5px;

      background-color: transparent;
    }

    .modal.modal--dark-mode #sentry {
      background-color: #262626;
    }

    .modal--transitionable {
      transition: all 0.5s ease-in-out;
    }
  `;
    async connectedCallback() {
        super.connectedCallback();
        const iframe = await this._iframe;
        iframe?.addEventListener("load", ()=>setTimeout(()=>{
                if (!this._port) this.dispatchError();
            }, 2000));
        iframe?.addEventListener("error", ()=>this.dispatchError());
        if (this.authParams && this.authParams.client_id) this.connectToApp();
    }
    updated(changedProperties) {
        if (changedProperties.has("authParams") || changedProperties.has("config")) this.connectToApp();
    }
    connectToApp() {
        window.addEventListener("message", this.onLastResort, {
            once: true
        });
        const environment = $466d3fc07826c612$var$getAppUrl(this.stage);
        (0, $347978f84fbb7aa9$export$9d816695ec3452c1)(environment).then((port)=>(0, $347978f84fbb7aa9$export$a08fb5cc915b7487)(port, this.appState)).then((port)=>{
            this._port = port;
            this.events = {
                popupOpenComplete: (0, $347978f84fbb7aa9$export$c9526fa4526c2c60)(port)((0, $347978f84fbb7aa9$export$6ddaf5c7fdb615c5)),
                popupOpenBlocked: (0, $347978f84fbb7aa9$export$c9526fa4526c2c60)(port)((0, $347978f84fbb7aa9$export$43a7920667fb5990)),
                modalOpenComplete: (0, $347978f84fbb7aa9$export$c9526fa4526c2c60)(port)((0, $347978f84fbb7aa9$export$6fdc11b9e9b0a645))
            };
            if (this.shadowRoot) {
                this.container = this.shadowRoot.getElementById("sentry-container");
                this.root = this.shadowRoot.getElementById("sentry");
            }
            return port;
        }).then((port)=>{
            const eventListener = (0, $347978f84fbb7aa9$export$5a3c9ae1fa6d7e61)(port)();
            eventListener.subscribe((event)=>this.onReceiveSentryEvent(event));
        }).catch((e)=>this.dispatchError(e.data));
    }
    onReceiveSentryEvent(event) {
        if (event.side === "proxy") this.dispatchEvent(new CustomEvent(event.name, {
            detail: event.data
        }));
        if (event.of((0, $347978f84fbb7aa9$export$47edff89ee5eefdb))) return this.openPopup(event.data);
        if (event.of((0, $347978f84fbb7aa9$export$b9a2c15ca74dee47))) {
            const { width: width, height: height } = event.data.dimensions;
            const firstOpen = !this.modalOpen;
            this.activateModal();
            if (this.root) {
                this.root.style.width = `${width}px`;
                this.root.style.height = `${height}px`;
                setTimeout(()=>{
                    this.events.modalOpenComplete();
                }, firstOpen ? 0 : 500);
            }
        }
        if (event.of((0, $347978f84fbb7aa9$export$4518ed92bbb25c89))) {
            this.modalOpen = false;
            if (this.root) {
                this.root.style.width = "100%";
                this.root.style.height = "100%";
                this.root.classList.remove("modal--transitionable");
                if (this.addModalTransitionableClassTimeout) {
                    clearTimeout(this.addModalTransitionableClassTimeout);
                    this.addModalTransitionableClassTimeout = null;
                }
            }
        }
    }
    openPopup(url) {
        const popupWindow = (0, $db3100f4fad4ddc1$export$83981d14e606a61f)({
            url: url,
            title: "SUSI Light Login",
            w: 459,
            h: 768
        });
        if (popupWindow) this.events?.popupOpenComplete();
        else this.events?.popupOpenBlocked();
    }
    activateModal() {
        if (!this.modalOpen && this.root) {
            this.modalOpen = true;
            this.requestUpdate();
            const timeout = setTimeout(()=>{
                this.root?.classList.add("modal--transitionable");
            }, 1000);
            this.addModalTransitionableClassTimeout = timeout;
        }
    }
    dispatchError(detail = {
        name: "unrecoverable"
    }) {
        this.dispatchEvent(new CustomEvent("on-error", {
            detail: detail
        }));
    }
    get appConfig() {
        return {
            ...this.config,
            popup: this.popup,
            variant: this.variant
        };
    }
    get authState() {
        return {
            ...this.authParams,
            wrapper: "true",
            popup: this.popup.toString(),
            asserted_origin: window.origin,
            sl_version: (0, $83a01ffb6406d320$export$83d89fbfd8236492),
            sl_build: (0, $83a01ffb6406d320$export$3f8fe6489e95757d),
            sl_buildtime: (0, $83a01ffb6406d320$export$126f857cb595c8fa)
        };
    }
    get appState() {
        return {
            authParams: this.authState,
            config: this.appConfig
        };
    }
    get url() {
        const baseUrl = $466d3fc07826c612$var$sentryUrl($466d3fc07826c612$var$getWrapperEnv(this.stage));
        const url = baseUrl(this.variant);
        for(const property in this.appState.authParams)url.searchParams.append(property, this.appState.authParams[property]);
        return url.href;
    }
    get isDarkMode() {
        return this.config.modal && !!this.authParams.dt;
    }
    render() {
        return (0, $jJTNo.html)`<section
      id="sentry-container"
      class=${(0, $0e5c059fc79abe53$export$56cc687933817664)({
            "modal-mode": this.config.modal,
            "modal--dark-mode": this.isDarkMode,
            modal: this.modalOpen
        })}
    >
      <section id="sentry">
        <iframe
          allowtransparency="true"
          frameborder="0"
          id="iframe"
          src="${this.url}"
        ></iframe>
      </section>
    </section>`;
    }
    constructor(...args){
        super(...args);
        this.container = null;
        this.root = null;
        this._port = null;
        this.variant = "large-buttons";
        this.popup = false;
        this.stage = false;
        this.modalOpen = false;
        this.modalTransitionable = false;
        this.addModalTransitionableClassTimeout = null;
        this.authParams = {};
        this.// eslint-disable-next-line
        config = {
            version: $83a01ffb6406d320$export$83d89fbfd8236492,
            build: $83a01ffb6406d320$export$3f8fe6489e95757d,
            buildTime: $83a01ffb6406d320$export$126f857cb595c8fa
        };
        this.onLastResort = (e)=>{
            const appUrl = $466d3fc07826c612$var$getAppUrl(this.stage);
            if (e.origin === appUrl) try {
                const event = (0, $347978f84fbb7aa9$export$d61e24a684f9e51).fromString(e.data);
                if (event && event.of((0, $347978f84fbb7aa9$export$c4a23014fbd7877d))) this.dispatchError(event.data);
            } catch (e) {
                this.dispatchError();
            }
        };
    }
};
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $1f45ba04a1effcd1$export$163dfc35cc43f240)("#iframe")
], $466d3fc07826c612$var$Sentry.prototype, "_iframe", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)()
], $466d3fc07826c612$var$Sentry.prototype, "variant", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Boolean
    })
], $466d3fc07826c612$var$Sentry.prototype, "popup", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Boolean
    })
], $466d3fc07826c612$var$Sentry.prototype, "stage", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Boolean
    })
], $466d3fc07826c612$var$Sentry.prototype, "modalTransitionable", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Number
    })
], $466d3fc07826c612$var$Sentry.prototype, "addModalTransitionableClassTimeout", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Object
    })
], $466d3fc07826c612$var$Sentry.prototype, "authParams", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Object
    })
], $466d3fc07826c612$var$Sentry.prototype, "config", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)()
], $466d3fc07826c612$var$Sentry.prototype, "appConfig", null);
$466d3fc07826c612$var$Sentry = (0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $07706bf0c990b886$export$da64fc29f17f9d0e)("susi-sentry")
], $466d3fc07826c612$var$Sentry);
var $466d3fc07826c612$export$2e2bcd8739ae039 = $466d3fc07826c612$var$Sentry;



parcelRequire("800sp");
var $4jdI8 = parcelRequire("4jdI8");
var $jJTNo = parcelRequire("jJTNo");
var $lPSdM = parcelRequire("lPSdM");

// dialog-component.js
class $d6bf75432012dc32$var$LitDialog extends (0, $lPSdM.LitElement) {
    static #_ = this.styles = (0, $4jdI8.css)`
    .dialog {
      display: none;
      position: fixed;
      z-index: 1000;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.5);
    }

    .dialog-content {
      background-color: #fff;
      margin: 15% auto;

      width: var(--dialog-width, 300px);
      height: var(--dialog-height, auto);
      border-radius: 10px;
      box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
      text-align: center;
      position: relative;
    }
  `;
    static #_1 = this.properties = {
        width: {
            type: String
        },
        height: {
            type: String
        }
    };
    constructor(){
        super();
        this.width = "300px";
        this.height = "auto";
        this.isOpen = false;
    }
    render() {
        return (0, $jJTNo.html)`
      <div
        class="dialog"
        style="display: ${this.isOpen ? "flex" : "none"}; justify-content: center; align-items: center;"
      >
        <div
          class="dialog-content"
          style="--dialog-width: ${this.width}; --dialog-height: ${this.height};"
        >
          <slot></slot>
        </div>
      </div>
    `;
    }
    openDialog() {
        this.isOpen = true;
    }
    closeDialog() {
        this.isOpen = false;
    }
}
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: String
    })
], $d6bf75432012dc32$var$LitDialog.prototype, "width", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: String
    })
], $d6bf75432012dc32$var$LitDialog.prototype, "height", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Boolean
    })
], $d6bf75432012dc32$var$LitDialog.prototype, "isOpen", void 0);
customElements.define("lit-dialog", $d6bf75432012dc32$var$LitDialog);


parcelRequire("800sp");
var $4jdI8 = parcelRequire("4jdI8");
var $jJTNo = parcelRequire("jJTNo");
var $lPSdM = parcelRequire("lPSdM");

const $ba3507ff95869a74$export$df1c34db1371eeed = [
    "ar-ae",
    "bg-bg",
    "cs-cz",
    "da-dk",
    "de-de",
    "el-gr",
    "en-ae",
    "en-gb",
    "en-hr",
    "en-il",
    "en-ke",
    "en-lk",
    "en-mo",
    "en-mu",
    "en-ng",
    "en-tt",
    "en-us",
    "en-vn",
    "en-xm",
    "es-bo",
    "es-do",
    "es-es",
    "es-la",
    "es-mx",
    "es-na",
    "es-pa",
    "es-py",
    "es-sv",
    "es-uy",
    "et-ee",
    "fi-fi",
    "fil-ph",
    "fr-ca",
    "fr-fr",
    "fr-ma",
    "fr-xm",
    "hi-in",
    "he-il",
    "hr-hr",
    "hu-hu",
    "id-id",
    "in-id",
    "it-it",
    "ja-jp",
    "ko-kr",
    "lt-lt",
    "lv-lv",
    "ms-my",
    "nb-no",
    "nl-nl",
    "pl-pl",
    "pt-br",
    "ro-ro",
    "ru-ru",
    "sk-sk",
    "sl-si",
    "sr-rs",
    "sr-sp",
    "sv-se",
    "th-th",
    "tr-tr",
    "uk-ua",
    "vi-vn",
    "zh-cn",
    "zh-hans",
    "zh-hant",
    "zh-mo",
    "zh-tw"
];


// Holds navigation briefly so host-side work queued by the same click — the
// analytics events the functional suite reads off window.SENTRY_EVENTS — lands
// before location.assign() tears the document down.
function $9580675555183ddd$var$preRedirectWork() {
    return new Promise((resolve)=>{
        setTimeout(resolve, 500);
    });
}
const $9580675555183ddd$var$searchParams = new URLSearchParams(window.location.search);
// Redirect-mode social sign-up return signal (spec § Transport: popup vs
// redirect — contextual-social-signup.md). The IMS/Authz callback wrote the
// Federated JWT as an HttpOnly cookie on `.services.adobe.com` and redirected
// the user back to us with `?open_susi_light=true`. Detect the param,
// scrub it from the URL via `history.replaceState` (so a refresh / share
// doesn't re-trigger), and pass it to <susi-sentry-light> as a property —
// the wrapper forwards it to the iframe via `iframeState.resumeSocial`, and
// the iframe's `app.ts` hands off to the socialFederated flow at boot. The
// credential itself stays in the cookie, never in JavaScript.
const $9580675555183ddd$var$OPEN_SUSI_LIGHT_PARAM = "open_susi_light";
const $9580675555183ddd$var$resumeSocialFromQuery = $9580675555183ddd$var$searchParams.get($9580675555183ddd$var$OPEN_SUSI_LIGHT_PARAM) === "true";
const $9580675555183ddd$var$authParams = [
    ...$9580675555183ddd$var$searchParams.entries()
].filter(([key])=>key !== "config" && key !== $9580675555183ddd$var$OPEN_SUSI_LIGHT_PARAM);
const $9580675555183ddd$var$config = JSON.parse($9580675555183ddd$var$searchParams.get("config") ?? "{}");
// `open_susi_light=true` in the return URL is honored purely on the
// presence of the redirect param — exactly what a production host does.
// Inline social sign-up enablement is NOT a host concern: it is server-driven
// per-client via `GET /v2/configurations` inside the iframe (see
// config/fetchConfig.ts and the flow's token-exchange-failed gate). If the
// feature is off for the client, the iframe escapes to Big SUSI on its own.
const $9580675555183ddd$var$resumeSocial = $9580675555183ddd$var$resumeSocialFromQuery;
// Strip the resume hint so a refresh / shared link doesn't re-trigger the
// bootstrap (spec § Host responsibilities in redirect mode, step 3).
if ($9580675555183ddd$var$resumeSocial) {
    const scrubbed = new URLSearchParams(window.location.search);
    scrubbed.delete($9580675555183ddd$var$OPEN_SUSI_LIGHT_PARAM);
    const newSearch = scrubbed.toString();
    window.history.replaceState(null, "", `${window.location.pathname}${newSearch ? `?${newSearch}` : ""}${window.location.hash}`);
}
const $9580675555183ddd$var$isPopup = typeof $9580675555183ddd$var$config.popup === "string" ? $9580675555183ddd$var$config.popup === "true" : Boolean($9580675555183ddd$var$config.popup);
// Defer mounting the SUSI Light web component until the user clicks a
// "Sign in" button. Lets us measure the warmed-cache scenario: the wrapper's
// hidden preload iframe primes the network in the background while the user
// looks at the button, so mounting <susi-sentry-light> later should be near
// instant.
//
// Resolution order:
//   1. `?useDialog=` query param wins if present (`true`/`false`).
//   2. Else default to `true` only for the react renderer (where preload
//      actually runs). All other renderers mount the component immediately
//      so the demo page stays demo-like.
const $9580675555183ddd$var$useDialogParam = $9580675555183ddd$var$searchParams.get("useDialog");
const $9580675555183ddd$var$useDialog = $9580675555183ddd$var$useDialogParam !== null ? $9580675555183ddd$var$useDialogParam !== "false" : $9580675555183ddd$var$config.renderer === "react";
let $9580675555183ddd$export$ba02cdc1645e032b = class SampleApp extends (0, $lPSdM.LitElement) {
    static #_ = this.styles = (0, $4jdI8.css)`
    * {
      box-sizing: border-box;
    }

    :host section {
      display: grid;
      grid-template-rows: 65px auto;
      background: var(--spectrum-gray-75) !important;
    }

    :host main {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      overflow-y: auto;
    }

    :host,
    section {
      width: 100%;
      height: 100%;
    }

    progress {
      visibility: hidden;
      width: 334px;
      margin-bottom: 20px;
    }

    progress.show {
      visibility: visible;
    }

    .language-picker {
      background-color: var(--spectrum-gray-75);
      border: solid 1px var(--spectrum-gray-200);
      color: var(--spectrum-gray-900);
      margin-left: 10px;
      padding: 5px;
    }

    .theme-button {
      background-color: var(--spectrum-gray-75);
      border: solid 1px var(--spectrum-gray-200);
      color: var(--spectrum-gray-900);
      margin-left: 10px;
      padding: 5px;
    }

    .card {
      display: flex;
      justify-content: center;
      align-items: center;

      background: var(--spectrum-gray-75, #fdfdfd);
      border-radius: 4px;
      border: solid 1px var(--spectrum-gray-200, #e6e6e6);
    }

    .card-full-width {
      width: 500px;
    }

    .card-express-theme {
      width: 360px;
      height: 500px;
      padding: 32px;
    }

    .card-large-buttons {
      width: 334px;
      height: 482px;
      padding: 26px;
    }

    .card-complete-account {
      width: 510px;
      height: 700px;
      padding: 56px;
    }

    .card iframe {
      width: 100%;
      height: 100%;
    }

    .code {
      width: 600px;
      font-size: 18px;
      word-break: break-word;
    }

    .adobe-logo {
      width: 85px;
      display: flex;
      justify-content: space-between;
    }

    .adobe-logo__text {
      font-weight: 700;
      font-size: 18px;
      color: #fa0f00;
    }

    .global-nav {
      display: flex;
      justify-content: center;
      background: var(--spectrum-gray-75);
      border-bottom: solid 1px var(--spectrum-gray-200);
      color: var(--spectrum-gray-900);
    }

    .global-nav__navigation {
      max-width: 1440px;
      flex-grow: 1;
    }

    .global-nav__navigation-list {
      display: flex;
    }

    .global-nav,
    .global-nav__navigation-list,
    .global-nav__navigation-list-item {
      height: 100%;
    }

    .global-nav__navigation-list,
    .global-nav__navigation-list-item {
      padding: 0;
      margin: 0;
    }

    .global-nav__navigation-list-item {
      display: flex;
      flex-direction: column;
      justify-content: center;
      font-family: adobe-clean, Source Sans Pro, -apple-system,
        BlinkMacSystemFont, Segoe UI, Roboto, sans-serif;
      font-size: 14px;
      font-weight: 400;
      margin: 0 16px;
    }

    .global-nav__navigation-list-item--right {
      margin-left: auto;
    }

    sp-switch {
      color: var(--spectrum-gray-900);
      font-family: adobe-clean, Source Sans Pro, -apple-system,
        BlinkMacSystemFont, Segoe UI, Roboto, sans-serif;
      font-size: 14px;
      padding: 10px;
    }

    .options-container {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-bottom: 24px;
    }

    .sign-in-cta {
      font-family: adobe-clean, Source Sans Pro, -apple-system,
        BlinkMacSystemFont, Segoe UI, Roboto, sans-serif;
      font-size: 16px;
      font-weight: 600;
      padding: 12px 32px;
      border-radius: 20px;
      border: 0;
      background: #1473e6;
      color: #fff;
      cursor: pointer;
    }

    .sign-in-cta:hover {
      background: #0d66d0;
    }

    .sign-in-cta:focus-visible {
      outline: 2px solid #1473e6;
      outline-offset: 2px;
    }

    .modal-backdrop {
      position: fixed;
      inset: 0;
      background: rgba(0, 0, 0, 0.5);
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 1000;
    }

    .modal-card {
      position: relative;
      padding: 24px;
      border-radius: 16px;
      max-height: 95vh;
      overflow: auto;
      /* .card sets align-items:center, which vertically centers the iframe once it's taller
         than this box's capped height — the overflowing top half then sits above the scrollable
         viewport, and centered start-side overflow isn't reachable by scrolling in most browsers.
         Aligning to the start keeps the iframe's true top at this box's top, so the whole height
         is reachable via the scrollbar. */
      align-items: flex-start;
      /* Thin, inset, rounded-thumb scrollbar — the default native scrollbar is a wide, flush,
         square-edged bar that visually clashes with this card's rounded corners. Firefox/modern
         Chromium read the standard properties; the ::-webkit- rules below cover Safari/Chrome. */
      scrollbar-width: thin;
      scrollbar-color: rgba(0, 0, 0, 0.25) transparent;
    }

    .modal-card::-webkit-scrollbar {
      width: 10px;
    }

    .modal-card::-webkit-scrollbar-track {
      background: transparent;
    }

    .modal-card::-webkit-scrollbar-thumb {
      background-color: rgba(0, 0, 0, 0.25);
      border-radius: 8px;
      /* Transparent border + content-box clip insets the visible thumb within the track, so it
         reads as a slim floating pill instead of a bar flush against the card's rounded edge. */
      border: 3px solid transparent;
      background-clip: content-box;
    }

    .modal-card::-webkit-scrollbar-thumb:hover {
      background-color: rgba(0, 0, 0, 0.4);
    }

    .modal-close {
      position: absolute;
      top: 16px;
      right: 16px;
      width: 28px;
      height: 28px;
      padding: 0;
      border: 0;
      border-radius: 50%;
      background: transparent;
      color: #2c2c2c;
      cursor: pointer;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      transition: background-color 0.15s ease;
      z-index: 1;
    }

    .modal-close:hover {
      background: #ebebeb;
    }

    .modal-close:focus-visible {
      outline: 2px solid #1473e6;
      outline-offset: 2px;
    }

    .modal-close svg {
      width: 14px;
      height: 14px;
      display: block;
    }

    .redirect-link {
      font-family: adobe-clean, Source Sans Pro, -apple-system;
      text-decoration: none;
    }

    section {
      height: 100%;
    }

    sp-theme {
      height: 100%;
    }
  `;
    connectedCallback() {
        super.connectedCallback();
        window.SENTRY_EVENTS = [];
        document.addEventListener("keydown", this._onEscape);
        const qs = new URLSearchParams(window.location.hash.substring(1));
        if (qs.has("access_token")) this._onToken({
            detail: qs.get("access_token")
        });
    }
    disconnectedCallback() {
        document.removeEventListener("keydown", this._onEscape);
        super.disconnectedCallback();
    }
    get isDarkMode() {
        const [_, dtValue] = $9580675555183ddd$var$authParams.find(([key])=>key === "dt") || [];
        return dtValue ? dtValue === "true" : window?.matchMedia("(prefers-color-scheme: dark)")?.matches;
    }
    firstUpdated(_changedProperties) {
        [
            "on-load",
            "on-auth-failed",
            "on-analytics",
            "on-modal-open",
            "on-modal-close"
        ].forEach((ev)=>{
            const sentryElement = this.shadowRoot?.querySelector("#sentry");
            if (sentryElement) sentryElement.addEventListener(ev, (e)=>{
                window.SENTRY_EVENTS.push({
                    name: e.type,
                    detail: e.detail
                });
            });
        });
    }
    async _onRedirect(e) {
        const redirectUri = e.detail;
        await $9580675555183ddd$var$preRedirectWork.apply(this);
        window.location.assign(redirectUri);
    }
    _onProviderClicked(e) {
        console.log("provider clicked", e.detail);
    }
    async _onToken(e) {
        console.log("on token", e.detail);
        // The redirect-mode social sign-up flow has handed off a token, so the
        // resume is complete. Clear the flag before any state change below
        // re-renders <susi-sentry-light> — otherwise the wrapper would re-mount the
        // iframe with resumeSocial still true and re-run the one-shot federated flow.
        this.resumeSocial = false;
        const token = e.detail;
        if ($9580675555183ddd$var$searchParams.get("disable_local_msw") === "true") this.token = token;
        await window.adobeIMS.refreshToken();
        this.userData = await window.adobeIMS.getProfile();
    }
    async _onAuthCode(e) {
        const code = e.detail;
        if ($9580675555183ddd$var$searchParams.get("disable_local_msw") === "true") this.token = code;
    }
    async _onAuthFailed(e) {
        // Every on-auth-failed reason is a terminal escape (see contextual-signin.md's event
        // table) — the host always navigates to fallbackUrl when one is present, regardless of
        // which reason produced it. Used to allowlist specific reasons (popup-blocked, ride-error),
        // which silently no-op'd for every new reason added since (existingFederatedOrEnterpriseAccount,
        // and all of postAuthGates'/completeAuthentication's reasons — profileChooserNeeded,
        // mandatoryProfilePending, emailVerificationRequired, termsOfUsePending, optionalProfilePending,
        // transient5xx, handover's own reasons) even though those already send a real fallbackUrl.
        if (e.detail.fallbackUrl) {
            await $9580675555183ddd$var$preRedirectWork.apply(this);
            window.location.assign(e.detail.fallbackUrl);
        }
    }
    async _onAnalytics(e) {
        console.log(e);
    }
    async _onError(e) {
        if (e.detail.name === "critical") console.error("critical", e);
        if (e.detail.name === "unrecoverable") console.error("unrecoverable", e);
    }
    onThemeChange() {
        this.authState = {
            ...this.authState,
            dt: !this.authState.dt
        };
    }
    get variant() {
        if ($9580675555183ddd$var$config.variant) return $9580675555183ddd$var$config.variant;
        return "standard";
    }
    get authParams() {
        const extraParams = {};
        const serviceParams = {};
        // Redirect back to whatever origin serves the sample — the sample runs on
        // local/stage/prestage/preprod/prod and should return to its own host. Was
        // hardcoded to the stage host, so this was only ever correct on stage.
        extraParams["redirect_uri"] = window.location.origin;
        if ($9580675555183ddd$var$searchParams.get("disable_local_msw") === "true") serviceParams["disable_local_msw"] = "true";
        return {
            ...this.authState,
            ...extraParams,
            ...serviceParams
        };
    }
    get autofocus() {
        return $9580675555183ddd$var$config?.autofocus?.toString();
    }
    openDialog(dimensions) {
        const dialog = this.shadowRoot?.getElementById("dialog");
        if (dialog && "openDialog" in dialog) dialog.openDialog();
        this.dialogOpen = true;
        this.dialogDimensions = dimensions;
    }
    closeDialog() {
        const dialog = this.shadowRoot?.getElementById("dialog");
        if (dialog) dialog.closeDialog();
        this.dialogOpen = false;
    }
    render() {
        return (0, $jJTNo.html)`
      <sp-theme theme="spectrum" color=${this.authState.dt ? "dark" : "light"}>
        <section>
          <header class="global-nav">
            <nav class="global-nav__navigation">
              <ul class="global-nav__navigation-list">
                <li class="global-nav__navigation-list-item">
                  <div class="adobe-logo">
                    <img
                      class="adobe-logo__icon"
                      src="https://www.adobe.com/content/dam/cc/icons/Adobe_Corporate_Horizontal_Red_HEX.svg"
                      width="25px"
                    />
                    <span class="adobe-logo__text">Adobe</span>
                  </div>
                </li>
                <li class="global-nav__navigation-list-item">
                  <a
                    href="https://git.corp.adobe.com/pages/adobe-identity/identity-sentry/"
                    class="redirect-link"
                    >Read Docs</a
                  >
                </li>
                <li class="global-nav__navigation-list-item">
                  <a
                    href="https://auth-light-tessera.identity-stage.adobe.com/"
                    class="redirect-link"
                    >React sample</a
                  >
                </li>
                <li
                  class="global-nav__navigation-list-item global-nav__navigation-list-item--right"
                >
                  ${this.userData ? (0, $jJTNo.html)`<span
                        >Signed in as ${this.userData?.displayName}</span
                      >` : (0, $jJTNo.html)`<span>Sign in</span>`}
                  ${this.userData?.email ? (0, $jJTNo.html)`<span>(${this.userData?.email})</span>` : (0, $jJTNo.nothing)}
                </li>
              </ul>
            </nav>
          </header>
          <main>
            ${this.token ? (0, $jJTNo.html)`<section id="token">${this.token}</section>` : (0, $jJTNo.nothing)}
            <div class="options-container">
              <select class="language-picker" @change=${this.localeChanged}>
                ${(0, $ba3507ff95869a74$export$df1c34db1371eeed).map((locale)=>(0, $jJTNo.html)`
                    <option
                      value=${locale}
                      ?selected=${locale === this.authParams.locale}
                    >
                      ${locale}
                    </option>
                  `)}
              </select>
              <button
                class="theme-button"
                type="button"
                @click=${this.onThemeChange}
              >
                Dark Mode: ${this.authState.dt ? "ON " : "OFF"}
              </button>
            </div>
            ${this.signInRequested ? $9580675555183ddd$var$useDialog ? (0, $jJTNo.html)`
                    <div
                      class="modal-backdrop"
                      role="presentation"
                      @click=${this.dismissSignIn}
                    >
                      <div
                        class=${`modal-card card card-${this.variant} ${$9580675555183ddd$var$config.fullWidth ? "card-full-width" : ""}`}
                        role="dialog"
                        aria-modal="true"
                        aria-label="Sign in"
                        @click=${this._stopClick}
                      >
                        <button
                          class="modal-close"
                          type="button"
                          aria-label="Close"
                          @click=${this.dismissSignIn}
                        >
                          <svg
                            viewBox="0 0 16 16"
                            fill="none"
                            aria-hidden="true"
                          >
                            <path
                              d="M3 3L13 13M13 3L3 13"
                              stroke="currentColor"
                              stroke-width="1.6"
                              stroke-linecap="round"
                            />
                          </svg>
                        </button>
                        ${[
            "edu-express",
            "react",
            "sandbox",
            "standard"
        ].includes(this.variant) ? this.susiLightElm() : this.susiLight()}
                      </div>
                    </div>
                  ` : (0, $jJTNo.html)`
                    <div
                      class=${`card card-${this.variant} ${$9580675555183ddd$var$config.fullWidth ? "card-full-width" : ""}`}
                    >
                      ${[
            "edu-express",
            "react",
            "sandbox",
            "standard"
        ].includes(this.variant) ? this.susiLightElm() : this.susiLight()}
                    </div>
                  ` : (0, $jJTNo.html)`
                  <button
                    class="sign-in-cta"
                    type="button"
                    @click=${this.onSignInClick}
                  >
                    Sign in
                  </button>
                `}

            <lit-dialog
              width=${`${this.dialogDimensions.width}px`}
              height=${`${this.dialogDimensions.height}px`}
              id="dialog"
            >
            </lit-dialog>
          </main>
        </section>
      </sp-theme>
    `;
    }
    constructor(...args){
        super(...args);
        this.isPopup = $9580675555183ddd$var$isPopup;
        this.resumeSocial = $9580675555183ddd$var$resumeSocial;
        // When `useDialog` is on (the default), we don't mount <susi-sentry-light>
        // until the user explicitly asks for it by clicking the Sign in button.
        // This flag flips once on first click and stays true for the rest of the
        // session.
        //
        // Auto-mount when `resumeSocial` is true so the user lands directly in
        // the in-progress UI after returning from redirect-mode social sign-up —
        // forcing them to click "Sign in" again would be confusing (the OAuth
        // step is already done).
        this.signInRequested = !$9580675555183ddd$var$useDialog || $9580675555183ddd$var$resumeSocial;
        this.userData = null;
        this.token = "";
        this.authState = {
            client_id: "sentry-test",
            scope: "AdobeID,openid",
            locale: "en-us",
            response_type: "token",
            ...$9580675555183ddd$var$authParams.reduce((acc, [key, value])=>({
                    ...acc,
                    [key]: value
                }), {}),
            dt: this.isDarkMode
        };
        this.config = {
            ...$9580675555183ddd$var$config,
            consentProfile: $9580675555183ddd$var$config.consentProfile ?? "adobe-id-sign-up",
            enableCompleteAccount: $9580675555183ddd$var$config.enableCompleteAccount ?? false,
            enableProgressiveAccount: $9580675555183ddd$var$config.enableProgressiveAccount ?? false
        };
        this._onEscape = (e)=>{
            if (e.key === "Escape" && this.signInRequested && $9580675555183ddd$var$useDialog) this.dismissSignIn();
        };
        this.onSignInClick = ()=>{
            this.signInRequested = true;
        };
        this.dismissSignIn = ()=>{
            this.signInRequested = false;
        };
        this._stopClick = (e)=>{
            e.stopPropagation();
        };
        this.localeChanged = (e)=>{
            this.authState = {
                ...this.authParams,
                locale: e.target.value
            };
        };
        this.dialogOpen = false;
        this.dialogDimensions = {
            width: 0,
            height: 0
        };
        this.susiLight = ()=>{
            return (0, $jJTNo.html)`<susi-sentry
      id="sentry"
      .authParams=${this.authParams}
      .config=${this.config}
      .popup=${this.isPopup}
      .variant=${this.variant}
      @on-auth-code=${this._onAuthCode}
      @on-auth-failed=${this._onAuthFailed}
      @on-error=${this._onError}
      @on-load=${(e)=>console.log("onload", e.detail.ready)}
      @on-provider-clicked=${this._onProviderClicked}
      @on-modal-open=${(e)=>{
                console.log("on complete account modal open", e.detail);
                this.openDialog(e.detail.dimensions);
            }}
      @on-modal-close=${(e)=>{
                console.log("on complete account modal close", e.detail);
                this.closeDialog();
            }}
      @on-token=${this._onToken}
      @redirect=${this._onRedirect}
    ></susi-sentry>`;
        };
        this.susiLightElm = ()=>{
            return (0, $jJTNo.html)`<susi-sentry-light
      id="sentry"
      .authParams=${this.authParams}
      .config=${this.config}
      .popup=${this.isPopup}
      .variant=${this.variant}
      .autofocus=${this.autofocus}
      .resumeSocial=${this.resumeSocial}
      @on-analytics=${this._onAnalytics}
      @on-auth-code=${this._onAuthCode}
      @on-auth-failed=${this._onAuthFailed}
      @on-error=${this._onError}
      @on-load=${(e)=>console.log("onload", e.detail.ready)}
      @on-provider-clicked=${this._onProviderClicked}
      @on-token=${this._onToken}
      @redirect=${this._onRedirect}
    ></susi-sentry-light>`;
        };
    }
};
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)()
], $9580675555183ddd$export$ba02cdc1645e032b.prototype, "isPopup", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Boolean
    })
], $9580675555183ddd$export$ba02cdc1645e032b.prototype, "resumeSocial", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Boolean
    })
], $9580675555183ddd$export$ba02cdc1645e032b.prototype, "signInRequested", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Object
    })
], $9580675555183ddd$export$ba02cdc1645e032b.prototype, "userData", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)()
], $9580675555183ddd$export$ba02cdc1645e032b.prototype, "token", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Object
    })
], $9580675555183ddd$export$ba02cdc1645e032b.prototype, "authState", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Object
    })
], $9580675555183ddd$export$ba02cdc1645e032b.prototype, "config", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)()
], $9580675555183ddd$export$ba02cdc1645e032b.prototype, "dialogOpen", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)()
], $9580675555183ddd$export$ba02cdc1645e032b.prototype, "dialogDimensions", void 0);
$9580675555183ddd$export$ba02cdc1645e032b = (0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $07706bf0c990b886$export$da64fc29f17f9d0e)("sample-app")
], $9580675555183ddd$export$ba02cdc1645e032b);




//# sourceMappingURL=index.d0514ca2.js.map
